import React, { useEffect, useState, useMemo, useRef } from "react";
import { Helmet } from "react-helmet";
import { Fade } from "react-reveal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DataParser from "../../../utlits/Dataparser";
import moment from "moment/moment";
import Sidebar from "../../Layouts/Sidebar";
import CreateTask from "./CreateTask";
import CreateProject from "../Projects/CreateProject";
import TaskServices from "../../../Services/TaskServices";
import ProjectServices from "../../../Services/ProjectServices";
import SprintServices from "../../../Services/SprintServices";
import DateField from "../../Reuseable/DateField";
import AssigneField from "../../Reuseable/AssigneField";
import LeadPendingField from "../../Reuseable/LeadPendingField";
import UserProfile from "../../Reuseable/UserProfile..jsx";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import EditTasks from "./EditTask";
import secureLocalStorage from "react-secure-storage";
import { message, DatePicker, Select, Tooltip, Popover } from "antd";
import ReactSelect from "react-select";
import SocketService from "../../../Services/SocketService";
import TaskNotesPopover from "./TaskNotesPopover";
import { ChevronDown } from "lucide-react";
import InlineSubtaskRow from './InlineSubtaskRow';
const { RangePicker } = DatePicker;
const { Option } = Select;

const STATUS_CONFIG = {
    "Complete":          { bg: "#eafbec", color: "#1CB333", text: "Complete" },
    "Completed":         { bg: "#eafbec", color: "#1CB333", text: "Completed" },
    "Pending":           { bg: "#fef7e0", color: "#DFA70D", text: "Pending" },
    "In Progress":       { bg: "#eef0fe", color: "#607EF9", text: "In Progress" },
    "In-Progress":       { bg: "#eef0fe", color: "#607EF9", text: "In Progress" },
    "On Hold":           { bg: "#e0fdf8", color: "#0DDFAB", text: "On Hold" },
    "On-Hold":           { bg: "#e0fdf8", color: "#0DDFAB", text: "On Hold" },
    "Pending-Approval":  { bg: "#ebebeb", color: "#1D1D1D", text: "Pending Approval" },
    "Pending Approval":  { bg: "#ebebeb", color: "#1D1D1D", text: "Pending Approval" },
    "Rejected":          { bg: "#ffebeb", color: "#FF0000", text: "Rejected" },
    "Cancelled":         { bg: "#ebebeb", color: "#1D1D1D", text: "Cancelled" },
};

const getStatusBadge = (status) => {
    const s = STATUS_CONFIG[status] || { bg: "#f1f5f9", color: "#475569", text: status || "—" };
    return (
        <span style={{
            background: s.bg, color: s.color,
            padding: "3px 10px", borderRadius: "5px",
            fontSize: "11px", fontWeight: "600",
            whiteSpace: "nowrap", display: "inline-block",
        }}>{s.text}</span>
    );
};

const Tasks = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [dateLoader, setDateLoader] = useState(false);
    const [currentDateFormat, setCurrentDateFormat] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [sortFilter, setSortFilter] = useState("due-date");
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editDrawerOpen, setEditDrawerOpen] = useState(false);
    const [tasksAssignetByME, setTaskAssignetByME] = useState([]);
    const [allOtherTasks, setllOtherTasks] = useState([]);
    const [tasksAssignetToME, setTaskAssignetToME] = useState([]);
    const [taskOwner, setTaskOwner] = useState([]);
    const [taskStatus, setTaskStatus] = useState(null);
    const [taskPriority, setTaskPriority] = useState([]);
    const [editId, setEditId] = useState("");
    const [taskSt, settaskSt] = useState("");
    const [taskFilter, setTaskFilter] = useState([]);
    const [userFilter, setUserFilter] = useState([]);
    const [priorityFilter, setPriorityFilter] = useState([]);
    const [dateRangeFilter, setDateRangeFilter] = useState(null);
    const [activeTimeFilter, setActiveTimeFilter] = useState(() =>
        location?.state?.taskFilter ? [location.state.taskFilter] : ["due_today"]
    );
    const [activeFilter, setActiveFilter] = useState("all");
    const [userPermissions, setuserPermissions] = useState([]);
    const [isBackgroundLoading, setIsBackgroundLoading] = useState(true);
    const [sidebarFilterData, setSidebarFilterData] = useState({ filter: null, rows: [], loading: false });
    const companyId = DataParser.CompanyId();
    const companyIdentifier = DataParser.CompanyIdentifier();

    const roleTitle = DataParser.userRoleTitle();
    const isHead = DataParser.isHead?.() === "yes";
    const userId = DataParser.UserId();

    const getCreatorRef = (task) => {
        if (!task) return null;
        // In this system, both 'created_by' and 'assignee' (singular) are used for creator.
        // After an update, leadview returns these as objects {id, ...}.
        const creatorId = task.created_by?.id || task.created_by || task.assignee?.id || task.assignee;
        return creatorId ? String(creatorId) : null;
    };

    const getAssigneeRef = (task) => {
        if (!task) return null;
        const assigneeRef = task.asigned_to?.id || task.asigned_to;
        return assigneeRef ? String(assigneeRef) : null;
    };

    const [parentIdForSubtask, setParentIdForSubtask] = useState(null);
    const [openedFromParentModal, setOpenedFromParentModal] = useState(false);
    const [taskNavStack, setTaskNavStack] = useState([]);
    const [inlineSubtaskParentId, setInlineSubtaskParentId] = useState(null);

    // Used inside EditTask modal — keeps modal-based creation intact
    const handleAddSubtask = (e, task) => {
        e?.stopPropagation();
        setParentIdForSubtask(task.id);
        setTimeout(() => {
            document.getElementById("hiddenCreateTaskBtn")?.click();
        }, 100);
    };

    // Used in the task list rows — opens an inline creation row instead of a modal
    const handleAddSubtaskInline = (e, task) => {
        e?.stopPropagation();
        setInlineSubtaskParentId(prev => prev === task.id ? null : task.id);
    };

    const handleCancelInlineSubtask = () => setInlineSubtaskParentId(null);

    const handleInlineSubtaskCreated = () => {
        setInlineSubtaskParentId(null);
        // Socket event will push the new subtask into the list automatically
    };

    const [title, setTitle] = useState("");
    const [assignedTo, setAssignedTo] = useState(null);
    const [dueDate, setDueDate] = useState(null);
    const [periority, setPeriority] = useState("");
    const [approval, setApproval] = useState("");
    const [status, setStatus] = useState("");
    const [description, setDescription] = useState("");
    const [isRecurring, setIsRecurring] = useState(false);
    const [recurringPeriod, setRecurringPeriod] = useState("");
    const [recurringTime, setRecurringTime] = useState("09:00");
    const [recurringTotalCount, setRecurringTotalCount] = useState(0);
    const [recurringExcludeDays, setRecurringExcludeDays] = useState([]);
    const [editParentDueDate, setEditParentDueDate] = useState(null);
    const [editLoading, setEditLoading] = useState(false);
    const [isUpdatingTask, setIsUpdatingTask] = useState(false);
    const [UpdateNotesAttac, setUpdateNotesAttac] = useState(null);
    const [projects, setProjects] = useState([]);
    const [pendingProjectTaskId, setPendingProjectTaskId] = useState(null);
    const [projectId, setProjectId] = useState(null);
    const [sprintId, setSprintId] = useState(null);

    const [TaskData, setTaskData] = useState(null);
    const [visibleTasksCount, setVisibleTasksCount] = useState(50);
    const [openSections, setOpenSections] = useState({});
    const [isLazyLoading, setIsLazyLoading] = useState(false);
    const isLazyLoadingRef = useRef(false);
    const loadedForCompanyId = useRef(null);
    const initialFilterApplied = useRef(false);
    const taskPriorityRef = useRef([]);
    const [TaskViewAttachment, setTaskViewAttachment] = useState(null);
    const [isUploding, setIsUploding] = useState(null);

    const [owner, setOwner] = useState(null);
    const [missingData, setMissingData] = useState([]);
    const [TaskNote, setTasKNote] = useState(null);
    const [TaskNotification, setTaskNotification] = useState(null);
    const [updatingNotes, setUpdatingNotes] = useState(false);

    // Add a ref to track the latest requested task ID and prevent race conditions
    const latestFetchId = React.useRef(null);

    const [openCommentTaskId, setOpenCommentTaskId] = useState(null);
    const openCommentTaskIdRef = React.useRef(null);
    const [commentTaskNotes, setCommentTaskNotes] = useState([]);

    const mentionUsers = useMemo(() => {
        return (taskOwner || []).map(u => ({
            id: u.id,
            display: `${u.first_name || ""} ${u.last_name || ""}`.trim(),
            image: u.image
        }));
    }, [taskOwner]);

    const handleOpenComments = async (task, open = true) => {
        if (!open) {
            setOpenCommentTaskId(null);
            openCommentTaskIdRef.current = null;
            return;
        }
        const taskId = task.id;
        setOpenCommentTaskId(taskId);
        openCommentTaskIdRef.current = taskId;
        setCommentTaskNotes([]); // Clear previous
        try {
            const res = await TaskServices.showTaskNote(taskId, { company_id: companyId });
            if (res && res.Good !== false) {
                setCommentTaskNotes(res.data || []);
            }
        } catch (err) {
            console.error("Failed to fetch task notes:", err);
        }
    };

    useEffect(() => {
        if (openCommentTaskId) {
            const count = commentTaskNotes.length;
            
            const updateItemNotesCount = (item) => {
                if (String(item.id) === String(openCommentTaskId)) {
                    return {
                        ...item,
                        notes_count: count,
                        comment_count: count,
                        final_note_count: count,
                        task_notes_count: count
                    };
                }
                if (item.sub_tasks && item.sub_tasks.length > 0) {
                    return {
                        ...item,
                        sub_tasks: item.sub_tasks.map(updateItemNotesCount)
                    };
                }
                return item;
            };

            setTaskAssignetToME(prev => prev.map(updateItemNotesCount));
            setTaskAssignetByME(prev => prev.map(updateItemNotesCount));
            setllOtherTasks(prev => prev.map(updateItemNotesCount));
        }
    }, [commentTaskNotes, openCommentTaskId]);

    const companyIdetifier = DataParser.CompanyIdentifier();

    const TASKS_CACHE_KEY = `planit_tasks_${companyId}`;
    const TASKS_CACHE_TTL = 60 * 1000; // 60 seconds

    const applyTaskData = (data) => {
        setTaskAssignetToME(data.tasks_assigned_to_me || []);
        setTaskAssignetByME(data.tasksByme || []);
        setTaskStatus(data.status);
        setTaskOwner(data.task_owner);
        if (data.all_other_tasks !== undefined) {
            setllOtherTasks(data.all_other_tasks);
        }
        setTaskPriority(data.priority);
        settaskSt(data.status);
        setIsLoading(false);
        setDateLoader(false);
        setLoading(false);
    };

    const loadSidebarFilter = (filter) => {
        if (!filter || filter === 'due_today' || filter === 'all') return;
        setSidebarFilterData({ filter, rows: [], loading: true });
        TaskServices.getTasksByFilter(companyId, filter).then((res) => {
            if (res.Good && res.data) {
                const data = res.data;
                const combined = [
                    ...(data.tasks_assigned_to_me || []),
                    ...(data.all_other_tasks || []),
                    ...(data.tasksByme || [])
                ];
                const seen = new Set();
                const rows = combined.filter(t => {
                    const id = String(t.id);
                    if (seen.has(id)) return false;
                    seen.add(id);
                    return true;
                });
                setSidebarFilterData({ filter, rows, loading: false });
            } else {
                setSidebarFilterData({ filter, rows: [], loading: false });
            }
        }).catch(() => {
            setSidebarFilterData({ filter, rows: [], loading: false });
        });
    };

    const reSetData = (skipTasks = false) => {
        // Show cached data immediately so the user sees tasks without waiting for the API
        let hasFreshCache = false;
        try {
            const cached = sessionStorage.getItem(TASKS_CACHE_KEY);
            if (cached) {
                const { data, ts } = JSON.parse(cached);
                if (Date.now() - ts < TASKS_CACHE_TTL) {
                    hasFreshCache = true;
                    applyTaskData(data);
                }
            }
        } catch (e) {}

        if (!hasFreshCache) {
            setLoading(true);
            setIsLoading(true);
        }

        setIsBackgroundLoading(true);

        // Phase 1 and Phase 2 start in parallel so sidebar filters get their data sooner.
        // Phase 2 merge only runs after Phase 1 has applied its data (to avoid overwrite).
        let phase1Applied = false;
        let pendingPhase2Data = null;

        const applyPhase2 = (allData) => {
            setTaskAssignetToME(prev => {
                const existingIds = new Set(prev.map(t => String(t.id)));
                const uniqueOthers = (allData.tasks_assigned_to_me || []).filter(t => !existingIds.has(String(t.id)));
                return [...prev, ...uniqueOthers];
            });
            setTaskAssignetByME(prev => {
                const existingIds = new Set(prev.map(t => String(t.id)));
                const uniqueOthers = (allData.tasksByme || []).filter(t => !existingIds.has(String(t.id)));
                return [...prev, ...uniqueOthers];
            });
            setllOtherTasks(prev => {
                const existingIds = new Set(prev.map(t => String(t.id)));
                const uniqueOthers = (allData.all_other_tasks || []).filter(t => !existingIds.has(String(t.id)));
                return [...prev, ...uniqueOthers];
            });
            if (allData.status) { setTaskStatus(allData.status); settaskSt(allData.status); }
            if (allData.task_owner) setTaskOwner(allData.task_owner);
            if (allData.priority) setTaskPriority(allData.priority);
            setIsBackgroundLoading(false);
        };

        // Phase 1: Due Today (fast — DB-filtered to today only)
        TaskServices.getDueTodayTask(companyId).then((res) => {
            if (res.data === "Un-Athunticated request") {
                secureLocalStorage.removeItem("adminInfo");
                secureLocalStorage.removeItem("admins");
                navigate("/");
                return;
            }
            if (!res.Good || !res.data || typeof res.data !== 'object') {
                setLoading(false);
                setIsLoading(false);
                return;
            }
            const data = res.data;
            applyTaskData(data);
            try { sessionStorage.setItem(TASKS_CACHE_KEY, JSON.stringify({ data, ts: Date.now() })); } catch (e) {}
            phase1Applied = true;
            // If Phase 2 already finished while Phase 1 was running, apply it now
            if (pendingPhase2Data) {
                applyPhase2(pendingPhase2Data);
                pendingPhase2Data = null;
            }
        }).catch(err => {
            console.error("Error fetching today's tasks:", err);
            setLoading(false);
            setIsLoading(false);
            setIsBackgroundLoading(false);
        });

        // Phase 2: All remaining tasks (starts immediately in parallel with Phase 1)
        TaskServices.getAllTask(companyId, { skipTasks }).then((resAll) => {
            if (resAll.data === "Un-Athunticated request") {
                secureLocalStorage.removeItem("adminInfo");
                secureLocalStorage.removeItem("admins");
                navigate("/");
                return;
            }
            if (resAll.Good && resAll.data) {
                if (phase1Applied) {
                    applyPhase2(resAll.data);
                } else {
                    // Phase 1 not done yet — store and apply once Phase 1 finishes
                    pendingPhase2Data = resAll.data;
                }
            } else {
                setIsBackgroundLoading(false);
            }
        }).catch(err => {
            console.error("Error fetching other tasks:", err);
            setIsBackgroundLoading(false);
        });

        ProjectServices.getAllProjects(companyId).then((res) => {
            if (res.Good) {
                setProjects(res.data.projects || []);
            }
        }).catch(err => console.error("Failed to fetch projects:", err));

        // If navigating from sidebar with a non-due_today filter, load that filter in parallel
        const sidebarFilter = location?.state?.taskFilter;
        if (sidebarFilter && sidebarFilter !== 'due_today' && sidebarFilter !== 'all') {
            loadSidebarFilter(sidebarFilter);
        }
    };

    const handleSubmit = (e, id) => {
        e.preventDefault();
        if (isRecurring && !recurringPeriod) {
            message.error("Please select a recurrence period for recurring tasks!");
            return;
        }
        setDateLoader(true);
        setIsUpdatingTask(true);

        // ✅ Date Validation: Task <= Sprint <= Project
        const selectedDate = moment(dueDate).startOf('day');
        const today = moment().startOf('day');

        if (selectedDate.isBefore(today)) {
            message.warning("Due date cannot be in the past");
            setDateLoader(false);
            setIsUpdatingTask(false);
            return;
        }

        if (sprintId?.due_date) {
            const sprintEnd = moment(sprintId.due_date).endOf('day');
            if (selectedDate.isAfter(sprintEnd)) {
                message.warning(`Task due date cannot exceed Sprint due date (${moment(sprintId.due_date).format("DD-MM-YYYY")})`);
                setDateLoader(false);
                setIsUpdatingTask(false);
                return;
            }
        } else if (projectId?.value) {
            const project = projects.find(p => String(p.id || p._id) === String(projectId.value));
            if (project?.due_date) {
                const projectEnd = moment(project.due_date).endOf('day');
                if (selectedDate.isAfter(projectEnd)) {
                    message.warning(`Task due date cannot exceed Project due date (${moment(project.due_date).format("DD-MM-YYYY")})`);
                    setDateLoader(false);
                    setIsUpdatingTask(false);
                    return;
                }
            }
        }

        const newDate = moment(dueDate).format("YYYY-MM-DD");
        const body = {
            company_id: companyId,
            company_identifier: companyIdentifier,
            title: title,
            assign_to: assignedTo,
            due_date: newDate,
            priority: periority,
            approval_required: approval,
            status: status,
            description: description,
            is_recurring: isRecurring,
            recurring_period: recurringPeriod,
            recurring_time: recurringTime,
            recurring_total_count: recurringTotalCount,
            recurring_exclude_days: recurringExcludeDays,
            project_id: projectId ? projectId.value : 0,
            sprint_id: sprintId ? sprintId.value : null,
        };
        TaskServices.updateTask(id, body)
            .then((res) => {
                // Optimistic update to show changes immediately while waiting for socket
                const optimisticData = {
                    ...body,
                    asigned_to: body.assign_to // Map key to match task object
                };
                handleLocalTaskUpdate(id, optimisticData);

                setDateLoader(false);
                setIsUpdatingTask(false);

                // Navigate to parent task only if we came from the parent modal; otherwise just close
                if (openedFromParentModal && TaskData && TaskData.parent_id && String(TaskData.parent_id) !== "0") {
                    const newStack = taskNavStack.slice(0, -1);
                    setTaskNavStack(newStack);
                    const fromParent = newStack.length > 0;
                    const dummyEvent = { preventDefault: () => {} };
                    handelEditDrawer(dummyEvent, TaskData.parent_id, fromParent, true);
                } else {
                    hideEditDrawer();
                }

            })
            .catch((err) => {
                console.log("Error Failed");
                setDateLoader(false);
                setIsUpdatingTask(false);
            });
    };

    const handleUpdaut = (e) => {
        e.preventDefault();
        TaskServices.getAllTask(companyId).then((res) => {
            if (res.data === "Un-Athunticated request") {
                secureLocalStorage.removeItem("adminInfo");
                secureLocalStorage.removeItem("admins");
                navigate("/");
                return;
            }
            if (!res.Good || !res.data || typeof res.data !== 'object') { setLoading(false); return; }
            const data = res.data;
            setTaskAssignetByME(data.tasksByme || []);
            setTaskStatus(data.status);
            setTaskOwner(data.task_owner);
            setllOtherTasks(data.all_other_tasks || []);
            setTaskAssignetToME(data.tasks_assigned_to_me || []);
            setTaskPriority(data.priority);
            setLoading(false);
        });
    };

    const handelEditDrawerForNotification = (id) => {
        setEditId(id);
        setEditLoading(true);
        setTaskData(null);
        setTitle("");
        setAssignedTo(null);
        setDueDate(null);
        setPeriority("");
        setApproval("");
        setStatus("");
        setDescription("");
        setOwner(null);
        setTasKNote([]);
        setTaskNotification([]);
        setUpdateNotesAttac([]);
        setTaskViewAttachment([]);
        fetchTaskDetails(id);
        // Small delay for notification-triggered opens (page may still be initialising)
        setTimeout(() => showEditDrawer(), 200);
    };

    useEffect(() => {
        setVisibleTasksCount(50);
    }, [searchValue, taskFilter, userFilter, priorityFilter, dateRangeFilter, activeTimeFilter]);

    useEffect(() => { taskPriorityRef.current = taskPriority || []; }, [taskPriority]);

    useEffect(() => {
        const isNoti = !!(location?.state?.isNotification || new URLSearchParams(location.search).get("id"));
        const alreadyLoadedThisCompany = loadedForCompanyId.current === String(companyId);
        const isFilterOnly = !!(location?.state?.taskFilter && !isNoti && !location?.state?.isProjectTask && alreadyLoadedThisCompany);
        if (!isFilterOnly) {
            reSetData(isNoti);
            loadedForCompanyId.current = String(companyId);
        } else {
            setLoading(false);
        }
        const datee = DataParser.getDateinFormat();
        const upermission = DataParser.CompanyUserPermissions();
        setuserPermissions(upermission);
        setCurrentDateFormat(datee);
        if (location?.state?.taskFilter) {
            setActiveTimeFilter([location.state.taskFilter]);
        } else if (!initialFilterApplied.current) {
            setActiveTimeFilter(["due_today"]);
        }
        initialFilterApplied.current = true;
        if (location?.state?.isNotification) {
            const id = location?.state?.TaskId;
            if (id) {
                handelEditDrawerForNotification(id);
            }
        } else {
            // Check for id in URL query parameters (e.g., from email links)
            const queryParams = new URLSearchParams(location.search);
            const taskId = queryParams.get("id");
            if (taskId) {
                console.log("🔗 Opening task from URL parameter ID:", taskId);
                handelEditDrawerForNotification(taskId);

                // Optional: Clear the parameter from URL to avoid re-opening on refresh? 
                // For now, keeping it simple as per "without disturbing anything else".
            }
        }

        // 🟢 Socket Integration
        SocketService.connect();

        const handleTaskUpdate = (payload) => {
            console.log("🔔 Real-time task update received (Raw):", payload);
            if (String(payload.company_id) !== String(companyId)) {
                console.log("❌ Task update ignored (Company ID mismatch):", payload.company_id, companyId);
                return;
            }
            console.log("✅ Task update matched company:", payload);
            // Cache is now stale — next reSetData will fetch fresh instead of showing old snapshot
            try { sessionStorage.removeItem(TASKS_CACHE_KEY); } catch (e) {}

            const { action, data, assignee, asigned_to } = payload;
            const currentUserId = DataParser.UserId();
            const roleTitle = DataParser.userRoleTitle();
            const isHead = DataParser.isHead?.() === "yes";

            // Enrich raw socket payload — priority_color/can_edit flags needed for create rows to render fully.
            const pData = taskPriorityRef.current.find(p => String(p.id) === String(data.priority));
            const isCreator = String(assignee) === String(currentUserId);
            const isAssignee = String(asigned_to) === String(currentUserId);
            const enrichedData = {
                ...data,
                priority_color: pData?.color || null,
                priority_name: pData?.name || null,
                can_edit: isCreator,
                can_edit_status: isCreator || isAssignee,
                can_edit_subtask: isCreator || isAssignee,
                notes_count: data.notes_count || 0,
                comment_count: data.comment_count || 0,
                sub_tasks: data.sub_tasks || [],
                subtask_count: data.subtask_count || 0,
            };

            if (action === "create") {
                if (String(asigned_to) === String(currentUserId)) {
                    setTaskAssignetToME(prev => {
                        if (prev.find(t => String(t.id) === String(enrichedData.id))) return prev;
                        return [enrichedData, ...prev];
                    });
                }
                if (String(assignee) === String(currentUserId)) {
                    setTaskAssignetByME(prev => {
                        if (prev.find(t => String(t.id) === String(enrichedData.id))) return prev;
                        return [enrichedData, ...prev];
                    });
                }

                // If this is a subtask, update the parent task's sub_tasks and subtask_count
                if (enrichedData.parent_id) {
                    const addSubToParent = (list) => list.map(t => {
                        if (String(t.id) === String(enrichedData.parent_id)) {
                            const alreadyIn = t.sub_tasks?.some(st => String(st.id) === String(enrichedData.id));
                            if (alreadyIn) return t;
                            return {
                                ...t,
                                sub_tasks: [enrichedData, ...(t.sub_tasks || [])],
                                subtask_count: (parseInt(t.subtask_count) || 0) + 1,
                            };
                        }
                        return t;
                    });
                    setTaskAssignetToME(prev => addSubToParent(prev));
                    setTaskAssignetByME(prev => addSubToParent(prev));
                    setllOtherTasks(prev => addSubToParent(prev));
                }

                // 🟢 Visibility Logic for "All Other Tasks"
            } else if (action === "create_subtask") {
                // 1. Add the subtask itself to relevant lists (since lists are flat)
                if (String(asigned_to) === String(currentUserId)) {
                    setTaskAssignetToME(prev => {
                        if (prev.find(t => String(t.id) === String(enrichedData.id))) return prev;
                        return [enrichedData, ...prev];
                    });
                }
                if (String(assignee) === String(currentUserId)) {
                    setTaskAssignetByME(prev => {
                        if (prev.find(t => String(t.id) === String(enrichedData.id))) return prev;
                        return [enrichedData, ...prev];
                    });
                }

                // 2. Update parent's count and sub_tasks array
                const addSub = (list) => list.map(t => {
                    if (String(t.id) === String(enrichedData.parent_id)) {
                        return {
                            ...t,
                            sub_tasks: t.sub_tasks ? [enrichedData, ...t.sub_tasks] : [enrichedData],
                            subtask_count: (parseInt(t.subtask_count) || 0) + 1
                        };
                    }
                    return t;
                });

                setTaskAssignetToME(prev => addSub(prev));
                setTaskAssignetByME(prev => addSub(prev));
                setllOtherTasks(prev => addSub(prev));

                // 🟢 Refresh current edit modal if this is a subtask for it
                if (data.parent_id && String(data.parent_id) === String(latestFetchId.current)) {
                    fetchTaskDetails(data.parent_id);
                }

            } else if (action === "delete") {
                // 1. Remove the task itself from all lists
                const removeTask = (list) => list.filter(t => String(t.id) !== String(data.id));

                // 2. Decrement parent's count and update sub_tasks array
                const updateParentOnDelete = (list) => list.map(t => {
                    if (data.parent_id && String(t.id) === String(data.parent_id)) {
                        return {
                            ...t,
                            sub_tasks: t.sub_tasks ? t.sub_tasks.filter(st => String(st.id) !== String(data.id)) : [],
                            subtask_count: Math.max(0, (parseInt(t.subtask_count) || 0) - 1)
                        };
                    }
                    return t;
                });

                setTaskAssignetToME(prev => updateParentOnDelete(removeTask(prev)));
                setTaskAssignetByME(prev => updateParentOnDelete(removeTask(prev)));
                setllOtherTasks(prev => updateParentOnDelete(removeTask(prev)));

            } else if (action === "update" || action === "status_update" || action === "add_note" || action === "delete_note" || action === "add_attachment" || action === "delete_attachment") {
                // For note actions, prioritize task_id over id (which might be the note_id)
                const taskId = (action === "add_note" || action === "delete_note") 
                    ? (data?.task_id || data?.id || payload?.task_id)
                    : (data?.id || data?.task_id || payload?.task_id);

                if (!taskId) return;

                // If the updated task is currently open in the drawer, refresh its details
                // Use latestFetchId.current instead of editId to avoid stale closure issues
                if (String(taskId) === String(latestFetchId.current)) {
                    fetchTaskDetails(taskId);
                }

                // If this task has an open comment popover, update its notes instantly
                if (String(taskId) === String(openCommentTaskIdRef.current)) {
                    if (action === "add_note" && data?.note) {
                        setCommentTaskNotes(prev => {
                            const isDuplicate = prev.some(n => 
                                String(n.id) === String(data.note.id) || 
                                (n.isOptimistic && n.notes === data.note.notes && String(n.user_id) === String(data.note.user_id))
                            );
                            if (isDuplicate) {
                                return prev.map(n => (n.isOptimistic && n.notes === data.note.notes) ? data.note : n);
                            }
                            return [...prev, data.note];
                        });
                    } else if (action === "delete_note" && (data?.id || data?.note_id)) {
                        const noteIdToDelete = data?.id || data?.note_id;
                        setCommentTaskNotes(prev => prev.filter(n => String(n.id) !== String(noteIdToDelete)));
                    } else {
                        TaskServices.showTaskNote(taskId, { company_id: companyId })
                            .then(res => {
                                if (res && res.data) setCommentTaskNotes(res.data);
                            });
                    }
                }
                // Update counts locally for add/delete actions
                if (action === "add_note" || action === "delete_note") {
                    const diff = action === "add_note" ? 1 : -1;
                    const updateCounts = (list) => list.map(t => {
                        if (String(t.id) === String(taskId)) {
                            return { ...t, notes_count: Math.max(0, (parseInt(t.notes_count) || 0) + diff) };
                        }
                        if (t.sub_tasks?.length > 0) return { ...t, sub_tasks: updateCounts(t.sub_tasks) };
                        return t;
                    });
                    setTaskAssignetToME(prev => updateCounts(prev));
                    setTaskAssignetByME(prev => updateCounts(prev));
                    setllOtherTasks(prev => updateCounts(prev));
                }
                
                // Fetch for complex updates (status, assignee, etc.)
                if (action !== "add_note" && action !== "delete_note") {
                    TaskServices.viewTask(taskId, { company_id: companyId })
                        .then((res) => {
                            if (res.data && res.data.task) {
                                const updatedTask = res.data.task;
                                const updateList = (list) => list.map(t => {
                                    if (String(t.id) === String(updatedTask.id)) return { ...t, ...updatedTask };
                                    if (t.sub_tasks?.length > 0) return { ...t, sub_tasks: updateList(t.sub_tasks) };
                                    return t;
                                });
                                setTaskAssignetToME(prev => updateList(prev));
                                setTaskAssignetByME(prev => updateList(prev));
                                setllOtherTasks(prev => updateList(prev));
                            }
                        }).catch(err => console.error("Error fetching updated task:", err));
                }
            }
        };

        // 🟢 Priority Update Listener
        const handlePriorityUpdate = (payload) => {
            if (String(payload.company_id) !== String(companyId)) return;
            console.log("🔔 Priority update received:", payload);

            const { action, data } = payload;

            setTaskPriority((prev) => {
                if (action === "create") {
                    return [...prev, data];
                } else if (action === "update") {
                    return prev.map(p => p.id === data.id ? { ...p, ...data } : p);
                } else if (action === "delete") {
                    return prev.filter(p => p.id !== Number(data.id));
                }
                return prev;
            });
        };

        // 🟢 JobStatus (Task Status) Update Listener
        const handleJobStatusUpdate = (payload) => {
            if (String(payload.company_id) !== String(companyId)) return;
            console.log("🔔 JobStatus update received:", payload);

            const { action, data } = payload;

            setTaskStatus((prev) => {
                if (!prev) return prev;
                if (action === "create") {
                    return [...prev, data];
                } else if (action === "update") {
                    return prev.map(s => s.id === data.id ? { ...s, ...data } : s);
                } else if (action === "delete") {
                    return prev.filter(s => s.id !== Number(data.id));
                }
                return prev;
            });
            settaskSt((prev) => {
                if (!prev) return prev;
                if (action === "create") {
                    return [...prev, data];
                } else if (action === "update") {
                    return prev.map(s => s.id === data.id ? { ...s, ...data } : s);
                } else if (action === "delete") {
                    return prev.filter(s => s.id !== Number(data.id));
                }
                return prev;
            });
        };

        SocketService.on("task_update", handleTaskUpdate);
        SocketService.on("priority_update", handlePriorityUpdate);
        SocketService.on("jobstatus_update", handleJobStatusUpdate);

        return () => {
            SocketService.off("task_update", handleTaskUpdate);
            SocketService.off("priority_update", handlePriorityUpdate);
            SocketService.off("jobstatus_update", handleJobStatusUpdate);
        };

    }, [location, companyId]);

    // 🟢 Dedicated Effect for Project Task Navigation (since it's a one-time thing on location change)
    useEffect(() => {
        if (location?.state?.isProjectTask) {
            setEditId(location?.state?.id);
            setEditDrawerOpen(true);
        }
    }, [location]);

    // 🟢 Dedicated Effect for Infinite Scroll Observer
    useEffect(() => {
        const maxFilteredLength = Math.max(
            ...activeTimeFilter.map(key => applyAllFilters(tasksToRender, key).length),
            0
        );

        const multiMode = activeTimeFilter.length > 1;
        const anySectionOpen = !multiMode || activeTimeFilter.some(key => openSections[key] !== false);

        // All tasks already visible — ensure spinner is off and skip creating observer
        if (maxFilteredLength <= visibleTasksCount || !anySectionOpen) {
            if (isLazyLoadingRef.current) {
                isLazyLoadingRef.current = false;
                setIsLazyLoading(false);
            }
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            // Only trigger if the user has actually scrolled (not just page loaded with short content)
            if (entries[0].isIntersecting && !isLazyLoadingRef.current && window.scrollY > 80) {
                isLazyLoadingRef.current = true;
                setIsLazyLoading(true);
                setTimeout(() => {
                    setVisibleTasksCount(prev => prev + 30);
                    isLazyLoadingRef.current = false;
                    setIsLazyLoading(false);
                }, 300);
            }
        }, { threshold: 0.1 });

        const sentinel = document.getElementById("task-list-sentinel");
        if (sentinel) observer.observe(sentinel);

        return () => observer.disconnect();
    }, [visibleTasksCount, tasksAssignetToME, tasksAssignetByME, allOtherTasks, searchValue, taskFilter, userFilter, priorityFilter, dateRangeFilter, activeTimeFilter, openSections]);

    const handelDrawer = (e) => {
        e.preventDefault();
        setDrawerOpen(!drawerOpen);
    };


    const handleLocalTaskUpdate = (taskId, newData) => {
        const updateList = (list) => list.map(t => {
            if (t.id === taskId) {
                return { ...t, ...newData };
            }
            if (t.sub_tasks) {
                return {
                    ...t,
                    sub_tasks: updateList(t.sub_tasks)
                };
            }
            return t;
        });

        setTaskAssignetToME(prev => updateList(prev));
        setTaskAssignetByME(prev => updateList(prev));
        setllOtherTasks(prev => updateList(prev));
    };

    const handleProjectSelected = (taskId, projectId, projectName, sprintId = null, sprintName = null) => {
        const body = {
            project_id: projectId,
            sprint_id: sprintId || null,
            company_id: DataParser.CompanyId(),
            company_identifier: DataParser.CompanyIdentifier(),
        };
        TaskServices.updateTaskProject(taskId, body)
            .then(res => {
                if (res.Good) {
                    handleLocalTaskUpdate(taskId, { project_id: projectId, project_name: projectName, sprint_id: sprintId, sprint_name: sprintName });
                    message.success(sprintId ? "Project & Sprint assigned" : "Project assigned");
                } else {
                    message.error(res.data || "Failed to assign project");
                }
            })
            .catch(() => message.error("Failed to assign project"));
    };

    const handleOpenCreateProjectForTask = (taskId) => {
        setPendingProjectTaskId(taskId);
        const el = document.getElementById("createProjectFromTaskModal");
        if (el && window.bootstrap?.Modal) {
            const bsModal = window.bootstrap.Modal.getInstance(el) || new window.bootstrap.Modal(el);
            bsModal.show();
        }
    };

    const handleProjectCreatedForTask = (projectId, projectName) => {
        if (pendingProjectTaskId) {
            handleProjectSelected(pendingProjectTaskId, projectId, projectName);
            setPendingProjectTaskId(null);
        }
    };



    const setComplete = (e, item) => {
        e.preventDefault();

        const id = item.id;
        const companyId = DataParser.CompanyId();
        const companyIdentifier = DataParser.CompanyIdentifier();

        const dataLead = {
            company_id: companyId,
            company_identifier: companyIdentifier,
            status: "Complete",
        };

        TaskServices.updateTaskStatus(id, dataLead)
            .then((res) => {
                // Check if backend sent a Good: true/false flag
                if (res.Good) {
                    if (res.data && res.data.toLowerCase().includes("approval is required")) {
                        message.warning(res.data);
                    } else {
                        message.success(res.data);
                        handleLocalTaskUpdate(id, { status: "Complete" });
                    }
                } else {
                    message.error(res.data || "Failed to complete task");
                }
            })
            .catch((err) => {
                console.error("Error updating task status:", err);

                if (err.response && err.response.data) {
                    message.error(err.response.data.data || "Server error while updating status");
                } else {
                    message.error("Server error while updating status");
                }
            });
    };

    const filterSearch = (data) => {
        const query = searchValue.trim().toLowerCase();
        if (!query) return data;

        return filterTasksRecursively(data, (task) =>
            task.title?.toLowerCase().includes(query)
        );
    };


    const filterByStatus = (data) => {
        if (!taskFilter) return data;
        return data.filter((el) => el.status === taskFilter);
    };

    const sortingByDifferent = (data) => {
        if (!sortFilter) return data;

        let sortedData = [...data];

        if (sortFilter === "due-date") {
            sortedData.sort((a, b) => {
                const dateA = a.due_date ? moment(a.due_date).valueOf() : Infinity;
                const dateB = b.due_date ? moment(b.due_date).valueOf() : Infinity;
                return dateA - dateB;
            });
        } else if (sortFilter === "assignee") {
            sortedData.sort((a, b) => {
                const aName = a.task_assigned_to?.first_name || "";
                const bName = b.task_assigned_to?.first_name || "";
                return aName.localeCompare(bName);
            });
        } else if (sortFilter === "status") {
            sortedData.sort((p1, p2) => {
                const s1 = p1.status || "";
                const s2 = p2.status || "";
                return s1.localeCompare(s2);
            });
        }

        const result = [];
        const addedIds = new Set();

        const parentIdsInFilteredList = new Set(sortedData.map(t => String(t.id)));

        const effectiveTopLevel = [];
        const effectiveSubtasksByParent = {};

        sortedData.forEach(task => {
            const parentId = task.parent_id;
            const hasParentInList = parentId && parentId !== 0 && parentId !== "0" && parentIdsInFilteredList.has(String(parentId));

            if (hasParentInList) {
                if (!effectiveSubtasksByParent[parentId]) {
                    effectiveSubtasksByParent[parentId] = [];
                }
                effectiveSubtasksByParent[parentId].push(task);
            } else {
                effectiveTopLevel.push(task);
            }
        });

        const appendTaskAndSubtasks = (task) => {
            if (addedIds.has(String(task.id))) return;
            result.push(task);
            addedIds.add(String(task.id));

            const subs = effectiveSubtasksByParent[task.id];
            if (subs && subs.length > 0) {
                subs.forEach(sub => {
                    appendTaskAndSubtasks(sub);
                });
            }
        };

        effectiveTopLevel.forEach(task => {
            appendTaskAndSubtasks(task);
        });

        return result;
    };

    const filterByTimeRange = (data) => {
        const today = moment().startOf('day');
        const userId = DataParser.UserId();

        switch (activeTimeFilter) {
            case 'all':
                return data;
            case 'due_today':
                return data.filter(task => {
                    if (!task.due_date) return false;
                    return moment(task.due_date).isSame(today, 'day');
                });
            case 'due_in_7_days':
                return data.filter(task => {
                    if (!task.due_date) return false;
                    const dueDate = moment(task.due_date);
                    return dueDate.isAfter(today) && dueDate.isSameOrBefore(today.clone().add(7, 'days'));
                });
            case 'delayed':
                return data.filter(task => {
                    if (!task.due_date) return false;
                    return moment(task.due_date).isBefore(today) && task.status !== 'Complete';
                });
            case 'created_by_me':
                return data.filter(task => getCreatorRef(task) === String(userId));

            case 'assigned_to_me':
                return data.filter(task => getAssigneeRef(task) === String(userId) && task.status !== 'Complete');
            case 'pending_approval':
                return data.filter(task => (task.approval_required === 'yes' || task.status === 'Pending-Approval' || task.status === 'Pending Approval') && task.status !== 'Complete');
            case 'recurring':
                return data.filter(task => (task.is_recurring === "true" || task.is_recurring === true) && task.status !== 'Complete');
            case 'complete':
                return data.filter(task => task.status === 'Complete');
            default:
                return data;
        }
    };

    const allFilter = (data) => {
        let filtered = filterSearch(data);
        filtered = filterByStatus(filtered);
        filtered = filterByTimeRange(filtered);
        filtered = sortingByDifferent(filtered);
        return filtered;
    };

    // Recursive filter helper
    const filterTasksRecursively = (tasks, filterFn) => {
        return tasks.reduce((acc, task) => {
            const matches = filterFn(task);
            const subTasks = task.sub_tasks ? filterTasksRecursively(task.sub_tasks, filterFn) : [];

            if (matches || subTasks.length > 0) {
                acc.push({ ...task, sub_tasks: subTasks });
            }
            return acc;
        }, []);
    };

    const checkTimeFilter = (task, filter) => {
        const today = moment().startOf('day');

        // For all filters except 'complete', exclude completed tasks
        if (filter !== 'complete' && task.status === 'Complete') {
            return false;
        }

        switch (filter) {
            case 'due_today':
                return task.due_date && moment(task.due_date).isSame(today, 'day');
            case 'due_in_7_days':
                if (!task.due_date) return false;
                const dueDate = moment(task.due_date);
                return dueDate.isAfter(today) && dueDate.isSameOrBefore(today.clone().add(7, 'days'));
            case 'delayed':
                const delayedCreatorId = task.created_by?.id || task.created_by;
                return task.due_date && moment(task.due_date).isBefore(today);

            case 'created_by_me':
                return getCreatorRef(task) === String(userId);
            case 'assigned_to_me':
                return String(task.asigned_to) === String(userId);
            case 'pending_approval':
                return task.approval_required === 'yes' || task.status === 'Pending-Approval' || task.status === 'Pending Approval';
            case 'recurring':
                return task.is_recurring === "true" || task.is_recurring === true;
            case 'complete':
                return task.status === 'Complete';
            default:
                return true;
        }
    };

    const flattenTaskList = (data) => {
        if (!data) return [];

        // Store original subtask counts before flattening
        const subtaskCounts = new Map();
        const storeSubtaskCounts = (tasks) => {
            tasks.forEach(task => {
                if (task.sub_tasks && task.sub_tasks.length > 0) {
                    subtaskCounts.set(String(task.id), task.sub_tasks.length);
                    storeSubtaskCounts(task.sub_tasks);
                }
            });
        };

        // Flatten all tasks and subtasks into a single list
        const flattenTasksRecursive = (tasks) => {
            const result = [];
            tasks.forEach(task => {
                // Add the current task, prioritizing explicit subtask_count
                const subtaskCount = task.subtask_count || subtaskCounts.get(String(task.id)) || 0;
                result.push({ ...task, sub_tasks: [], subtask_count: subtaskCount });
                // Recursively add all subtasks
                if (task.sub_tasks && task.sub_tasks.length > 0) {
                    result.push(...flattenTasksRecursive(task.sub_tasks));
                }
            });
            return result;
        };

        // Deduplicate tasks by ID first
        const uniqueTasksMap = new Map(data.map(item => [String(item.id), item]));
        const allTasks = Array.from(uniqueTasksMap.values());

        // Store subtask counts before flattening
        storeSubtaskCounts(allTasks);

        // Flatten all tasks including subtasks
        let flatTasks = flattenTasksRecursive(allTasks);

        const uniqueFlatMap = new Map(flatTasks.map(item => [String(item.id), item]));
        return Array.from(uniqueFlatMap.values());
    };

    const applyDropdownFilters = (flattenedData) => {
        let filtered = [...flattenedData];

        // Apply project filter from URL (for navigation from Projects screen)
        const queryParams = new URLSearchParams(location.search);
        const projectIdFromUrl = queryParams.get("project_id");
        if (projectIdFromUrl) {
            filtered = filtered.filter(task => String(task.project_id) === String(projectIdFromUrl));
        }

        // Apply search filter
        filtered = filterSearch(filtered);

        // Apply status filter
        if (taskFilter && taskFilter.length > 0) {
            filtered = filtered.filter((task) => taskFilter.includes(task.status));
        }

        // Apply user filter
        if (userFilter && userFilter.length > 0) {
            filtered = filtered.filter((task) => {
                const assigneeId = parseInt(task.asigned_to);
                const taskAssignedToId = parseInt(task.task_assigned_to?.id);

                return userFilter.some(id =>
                    parseInt(id) === assigneeId ||
                    parseInt(id) === taskAssignedToId
                );
            });
        }

        // Apply date range filter
        if (dateRangeFilter && dateRangeFilter[0] && dateRangeFilter[1]) {
            filtered = filtered.filter((task) => {
                const taskDate = moment(task.due_date);
                return taskDate.isBetween(dateRangeFilter[0], dateRangeFilter[1], 'day', '[]');
            });
        }

        // Apply priority filter
        if (priorityFilter && priorityFilter.length > 0) {
            filtered = filtered.filter(task => priorityFilter.includes(String(task.priority)));
        }

        return filtered;
    };

    const applyCurrentVisibility = (tasks, targetTimeFilter) => {
        const isStatusFiltered = taskFilter && taskFilter.includes("Complete");
        const isCompleteTab = targetTimeFilter === 'complete';

        if (isStatusFiltered || isCompleteTab) {
            return tasks; // Show everything if explicitly requested
        }
        // Otherwise, hide Completed tasks
        return tasks.filter(task => task.status !== 'Complete');
    };

    const applyAllFilters = (data, filterKey = 'all') => {
        if (!data) return [];
        let filtered = flattenTaskList(data);
        filtered = applyDropdownFilters(filtered);
        filtered = applyCurrentVisibility(filtered, filterKey);
        if (filterKey !== 'all') {
            filtered = filtered.filter((task) => checkTimeFilter(task, filterKey));
        }
        filtered = sortingByDifferent(filtered);
        return filtered;
    };

    const fetchTaskDetails = (id) => {
        latestFetchId.current = String(id); // track the latest fetch to prevent race conditions

        const body = {
            company_id: companyId,
        };
        TaskServices.viewTask(id, body)
            .then((res) => {
                // Ignore stale responses if the user has clicked another task in the meantime
                if (latestFetchId.current !== String(id)) {
                    console.log("Ignored stale task response for ID:", id);
                    return;
                }

                const data = res.data?.task;
                if (!data) {
                    setEditLoading(false);
                    return;
                }

                setTaskData(data);

                // Sync the authoritative subtask_count from the server back into the
                // flat task list arrays so the badge in the main table stays current.
                // This is needed because subtask creation inside the EditTask modal only
                // calls fetchTaskDetails (which refreshes the modal) but does NOT patch
                // the parent task row in the main list — causing subtask_count to stay at 0.
                if (data.subtask_count != null) {
                    const countsMap = new Map();
                    countsMap.set(String(id), data.subtask_count);
                    if (data.sub_tasks) {
                        data.sub_tasks.forEach(st => {
                            if (st.subtask_count !== undefined) {
                                countsMap.set(String(st.id), st.subtask_count);
                            }
                        });
                    }

                    const syncCount = (list) =>
                        list.map((t) => {
                            const tIdStr = String(t.id);
                            if (countsMap.has(tIdStr)) {
                                return { ...t, subtask_count: countsMap.get(tIdStr) };
                            }
                            return t;
                        });
                    setTaskAssignetToME((prev) => syncCount(prev));
                    setTaskAssignetByME((prev) => syncCount(prev));
                    setllOtherTasks((prev) => syncCount(prev));
                }
                setTitle(data.title);
                setAssignedTo(data.asigned_to);
                setDueDate(data.due_date);
                setPeriority(data.priority);
                setApproval(data.approval_required);
                setStatus(data.status);
                setDescription(data.description);
                setIsRecurring(data.is_recurring || false);
                setRecurringPeriod(data.recurring_period || "");
                setRecurringTime(data.recurring_time || "09:00");
                setRecurringTotalCount(data.recurring_total_count || 0);
                setRecurringExcludeDays(Array.isArray(data.recurring_exclude_days) ? data.recurring_exclude_days : []);
                setOwner(data.created_by);
                
                if (data.project_id) {
                    setProjectId({ value: data.project_id, label: data.project_name || "Project " + data.project_id });
                } else {
                    setProjectId(null);
                }

                if (data.sprint_id) {
                    setSprintId({ value: data.sprint_id, label: data.sprint_name || "Sprint " + data.sprint_id });
                } else {
                    setSprintId(null);
                }

                // Set additional data from the SAME response object
                setTasKNote(data.task_notes || []);
                setTaskNotification(data.task_notifications || []);
                setUpdateNotesAttac(data.task_notes_attachments || []);
                setTaskViewAttachment(data.task_attachments || []);

                // Resolve parent task due date for subtask due-date constraint
                if (data.parent_id && String(data.parent_id) !== "0") {
                    const allKnownTasks = [...(tasksAssignetToME || []), ...(allOtherTasks || []), ...(tasksAssignetByME || [])];
                    const findParent = (list, pid) => {
                        for (const t of list) {
                            if (String(t.id) === String(pid)) return t;
                            if (t.sub_tasks) { const r = findParent(t.sub_tasks, pid); if (r) return r; }
                        }
                        return null;
                    };
                    const parent = findParent(allKnownTasks, data.parent_id);
                    setEditParentDueDate(parent?.due_date || null);
                } else {
                    setEditParentDueDate(null);
                }

                setLoading(false);
                setEditLoading(false);
                setIsUploding(false);
            })
            .catch((err) => {
                console.log(err);
                // message.error("Failed to fetch task details.");
                setLoading(false);
                setEditLoading(false);
            });
    };

    // Keep these for standalone updates (e.g. after adding a note), but reuse fetchTaskDetails where possible if full refresh needed
    const TaskNotes = (id) => fetchTaskDetails(id);
    const TaskNotifications = (id) => fetchTaskDetails(id);

    const handelDeleteNote = (e, ids) => {
        e.preventDefault();

        const data = {
            company_id: companyId,
            company_identifier: companyIdentifier,
        };
        TaskServices.deleteTaskNote(ids, data).then((res) => {
            // We can just refetch all details to be safe and consistent
            fetchTaskDetails(editId);
            setUpdatingNotes(!updatingNotes);
        });
    };
    const TaskNotesAttachmentImages = (id) => fetchTaskDetails(id);
    const TaskAttachmentImages = (id) => fetchTaskDetails(id);

    const showEditDrawer = () => {
        const drawerElement = document.getElementById("offcanvasRight2");
        if (drawerElement) {
            const bsOffcanvas = window.bootstrap?.Offcanvas?.getInstance(drawerElement) ||
                (window.bootstrap?.Offcanvas ? new window.bootstrap.Offcanvas(drawerElement) : null);
            if (bsOffcanvas) bsOffcanvas.show();
        }
    };

    const hideEditDrawer = () => {
        const drawerElement = document.getElementById("offcanvasRight2");
        if (drawerElement) {
            const bsOffcanvas = window.bootstrap?.Offcanvas?.getInstance(drawerElement);
            if (bsOffcanvas) bsOffcanvas.hide();
        }
    };

    const handelEditDrawer = (e, id, fromParentModal = false, skipStackUpdate = false) => {
        e.preventDefault();
        if (!skipStackUpdate) {
            if (fromParentModal) {
                setTaskNavStack(prev => [...prev, editId]);
            } else {
                setTaskNavStack([]);
            }
        }
        setOpenedFromParentModal(fromParentModal);
        setEditId(id);
        setEditLoading(true);

        // Pre-populate owner from local data to avoid flicker
        const allKnownTasks = [...(tasksAssignetToME || []), ...(allOtherTasks || []), ...(tasksAssignetByME || [])];
        const findTask = (list, tid) => {
            for (let t of list) {
                if (String(t.id) === String(tid)) return t;
                if (t.sub_tasks) { const found = findTask(t.sub_tasks, tid); if (found) return found; }
            }
            return null;
        };
        const localTask = findTask(allKnownTasks, id);

        setTaskData(null);
        setTitle("");
        setAssignedTo(null);
        setDueDate(null);
        setPeriority("");
        setApproval("");
        setStatus("");
        setDescription("");
        setOwner(localTask ? localTask.created_by : null);
        setTasKNote([]);
        setTaskNotification([]);
        setUpdateNotesAttac([]);
        setTaskViewAttachment([]);
        setEditParentDueDate(null);

        fetchTaskDetails(id);

        // No remount needed (key removed) — show the persistent offcanvas directly
        showEditDrawer();
    };

    // Called by EditTask's back arrow or X button
    const handleEditTaskClose = () => {
        if (openedFromParentModal && TaskData && TaskData.parent_id && String(TaskData.parent_id) !== "0") {
            const newStack = taskNavStack.slice(0, -1);
            setTaskNavStack(newStack);
            const fromParent = newStack.length > 0;
            const dummyEvent = { preventDefault: () => {} };
            handelEditDrawer(dummyEvent, TaskData.parent_id, fromParent, true);
        } else {
            hideEditDrawer();
        }
    };

    const openTaskCreate = () => {
        document.querySelector("#createTask").click();
        navigate(`/${companyIdetifier}/tasks`, {
            state: null,
        });
    };

    const handleCreateTask = (e) => {
        e.preventDefault();
        if (isLoading) return; // Prevent clicking while loading
        const missingItems = [];
        if (!taskPriority || taskPriority.length === 0) {
            missingItems.push({ name: "Task Priority", path: `/${companyIdentifier}/priority` });
        }

        if (missingItems.length > 0) {
            setMissingData(missingItems);
            document.getElementById("hiddenPrereqModalBtn")?.click();
        } else {
            // Trigger the hidden button to open the offcanvas
            document.getElementById("hiddenCreateTaskBtn").click();
        }
    };

    const isElementLoaded = async (selector) => {
        while (document.querySelector(selector) === null) {
            await new Promise((resolve) => requestAnimationFrame(resolve));
        }
        return document.querySelector(selector);
    };



    const tasksToRender = useMemo(() => {
        const seen = new Set();
        return [...(tasksAssignetToME || []), ...(allOtherTasks || []), ...(tasksAssignetByME || [])].filter(t => {
            const id = String(t.id);
            if (seen.has(id)) return false;
            seen.add(id);
            return true;
        });
    }, [tasksAssignetToME, allOtherTasks, tasksAssignetByME]);

    const _flatFiltered = useMemo(
        () => applyDropdownFilters(flattenTaskList(tasksToRender)),
        [tasksToRender, searchValue, taskFilter, userFilter, priorityFilter, dateRangeFilter, location.search]
    );

    const chipCounts = useMemo(() => {
        const today = moment().startOf('day');
        const uid = String(DataParser.UserId());
        const isStatusFiltered = taskFilter && taskFilter.includes("Complete");
        const ftVisible = isStatusFiltered ? _flatFiltered : _flatFiltered.filter(t => t.status !== 'Complete');
        return {
            all: ftVisible.length,
            due_today: ftVisible.filter(t => t.due_date && moment(t.due_date).isSame(today, 'day')).length,
            due_in_7_days: ftVisible.filter(t => { if (!t.due_date) return false; const d = moment(t.due_date); return d.isAfter(today) && d.isSameOrBefore(today.clone().add(7, 'days')); }).length,
            delayed: ftVisible.filter(t => t.due_date && moment(t.due_date).isBefore(today)).length,
            created_by_me: ftVisible.filter(t => getCreatorRef(t) === uid).length,
            assigned_to_me: ftVisible.filter(t => getAssigneeRef(t) === uid).length,
            pending_approval: ftVisible.filter(t => t.approval_required === 'yes' || t.status === 'Pending-Approval' || t.status === 'Pending Approval').length,
            recurring: ftVisible.filter(t => t.is_recurring === "true" || t.is_recurring === true).length,
            complete: _flatFiltered.filter(t => t.status === 'Complete').length,
        };
    }, [_flatFiltered, taskFilter]);

    const filteredRowsByKey = useMemo(() => {
        const result = {};
        activeTimeFilter.forEach(key => {
            // While Phase 2 is still loading AND this filter has dedicated sidebar data ready, use it
            if (isBackgroundLoading && sidebarFilterData.filter === key && !sidebarFilterData.loading) {
                let rows = applyDropdownFilters(sidebarFilterData.rows);
                rows = applyCurrentVisibility(rows, key);
                rows = sortingByDifferent(rows);
                result[key] = rows;
            } else {
                result[key] = applyAllFilters(tasksToRender, key);
            }
        });
        return result;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tasksToRender, activeTimeFilter, searchValue, taskFilter, userFilter, priorityFilter, dateRangeFilter, sortFilter, location.search, sidebarFilterData, isBackgroundLoading]);

    // Tasks due today that belong to a project — used for "Today's Projects" section
    const todayProjectTasks = useMemo(() => {
        return _flatFiltered.filter(t =>
            t.project_id && t.project_id !== 0 &&
            t.due_date && moment(t.due_date).isSame(moment(), 'day') &&
            t.status !== 'Complete'
        );
    }, [_flatFiltered]);

    // Shared column widths used by both header and rows
    const COL = { created: '160px', assigned: '170px', date: '120px', status: '120px', comment: '130px', project: '160px' };
    const COL_CLASS = { created: 'task-col-created', assigned: 'task-col-assigned', date: 'task-col-date', status: 'task-col-status', comment: 'task-col-comment', project: 'task-col-project' };
    const headSt = { fontSize: '13px', fontWeight: '600', color: '#212529', textAlign: 'left', display: 'block' };


    return (
        <>
            <Helmet>
                <title>Tasks - Planit</title>
            </Helmet>
            <div className="main-content">
                <style>{`
                    .task-row .task-row-actions {
                        opacity: 0;
                        visibility: hidden;
                        transition: all 0.2s ease;
                    }
                    .task-row:hover .task-row-actions {
                        opacity: 1;
                        visibility: visible;
                    }
                    .subtask-badge:hover {
                        background: #1d1d1d !important;
                        color: #ffffff !important;
                    }
                `}</style>
                <div className="page-content">

                    <div className="container-fluid px-4 pb-4 pt-0">
                        <CreateProject
                            id="createProjectFromTaskModal"
                            labelledby="createProjectFromTaskLabel"
                            closeBtnId="createProjectFromTaskClose"
                            reFreshData={() => reSetData()}
                            onProjectCreated={handleProjectCreatedForTask}
                        />

                        <CreateTask
                        parentId={parentIdForSubtask}
                        id="offcanvasRight"
                        labelledby="offcanvasRightLabel"
                            setDrawerOpen={(open) => {
                                setDrawerOpen(open);
                                if (!open) setParentIdForSubtask(null);
                            }}
                            priority={taskPriority}
                            statuses={taskStatus}
                            taskOwner={taskOwner}
                            handelDrawer={() => {
                                setDrawerOpen(false);
                                setParentIdForSubtask(null);
                            }}
                            reFreshData={() => {
                                reSetData();
                            }}
                        />

                        <>
                            {(userPermissions || []).indexOf("tasks-edit") !== -1 ? (
                                <>
                                    <EditTasks
                                        mid={`offcanvasRight2`}
                                        labelledby={`offcanvasRightLabel2`}
                                        setTaskAssignetToME={setTaskAssignetToME}
                                        tasksAssignetToME={tasksAssignetToME}
                                        allTasks={tasksToRender}
                                        setDrawerOpen={editDrawerOpen}
                                        priority={taskPriority}
                                        reFreshData={() => reSetData()}
                                        statuses={taskStatus}
                                        taskOwner={taskOwner}
                                        handelDrawer={handelEditDrawer}
                                        EditId={editId}
                                        title={title}
                                        assignedTo={assignedTo}
                                        dueDate={dueDate}
                                        periority={periority}
                                        approval={approval}
                                        status={status}
                                        description={description}
                                        setTitle={setTitle}
                                        setAssignedTo={setAssignedTo}
                                        setDueDate={setDueDate}
                                        setPeriority={setPeriority}
                                        setApproval={setApproval}
                                        setStatus={setStatus}
                                        setDescription={setDescription}
                                        userPermissions={userPermissions}
                                        projects={projects}
                                        projectId={projectId}
                                        setProjectId={setProjectId}
                                        TaskData={TaskData}
                                        TaskViewAttachment={TaskViewAttachment}
                                        setTaskViewAttachment={setTaskViewAttachment}
                                        recurringExcludeDays={recurringExcludeDays}
                                        setRecurringExcludeDays={setRecurringExcludeDays}
                                        owner={owner}
                                        loading={editLoading}
                                        editLoading={editLoading}
                                        setEditLoading={setEditLoading}
                                        isUpdatingTask={isUpdatingTask}
                                        isRecurring={isRecurring}
                                        recurringPeriod={recurringPeriod}
                                        setIsRecurring={setIsRecurring}
                                        setRecurringPeriod={setRecurringPeriod}
                                        recurringTime={recurringTime}
                                        setRecurringTime={setRecurringTime}
                                        recurringTotalCount={recurringTotalCount}
                                        setRecurringTotalCount={setRecurringTotalCount}
                                        parentDueDate={editParentDueDate}
                                        TaskNotification={TaskNotification}
                                        TaskNote={TaskNote} setTasKNote={setTasKNote}
                                        setOwner={setOwner}
                                        setUpdatingNotes={setUpdatingNotes}
                                        updatingNotes={updatingNotes}
                                        TaskNotes={(e) => TaskNotes(e)}
                                        handelDeleteNote={(e, ids) => handelDeleteNote(e, ids)}
                                        handleSubmit={handleSubmit}
                                        UpdateNotesAttac={UpdateNotesAttac}
                                        setUpdateNotesAttac={setUpdateNotesAttac}
                                        TaskNotesAttachmentImages={TaskNotesAttachmentImages}
                                        isUploding={isUploding}
                                        setIsUploding={setIsUploding}
                                        TaskAttachmentImages={TaskAttachmentImages}
                                        TaskNotifications={TaskNotifications}
                                        fetchTaskDetails={fetchTaskDetails}
                                        sprintId={sprintId}
                                        setSprintId={setSprintId}
                                        handleAddSubtask={handleAddSubtask}
                                        onCloseDrawer={handleEditTaskClose}
                                        openedFromParentModal={openedFromParentModal}
                                    />
                                </>
                            ) : null}
                            {/* Project Filter Indicator */}
                            {new URLSearchParams(location.search).get("project_id") && (
                                <div className="alert alert-info py-2 px-3 mb-2 d-flex align-items-center justify-content-between shadow-sm" style={{ fontSize: '13px', borderRadius: '8px', borderLeft: '4px solid #0DDFAB', backgroundColor: '#f2fffb', borderColor: '#f2fffb' }}>
                                    <div className="d-flex align-items-center">
                                        <i className="fa-solid fa-folder-open me-2" style={{ color: '#0DDFAB' }}></i>
                                        <span className="text-dark">Filtering tasks by <strong>Project</strong></span>
                                    </div>
                                    <button 
                                        className="btn btn-sm btn-link text-decoration-none p-0 fw-bold" 
                                        style={{ color: '#0DDFAB', fontSize: '12px' }}
                                        onClick={() => {
                                            const params = new URLSearchParams(location.search);
                                            params.delete("project_id");
                                            navigate({ search: params.toString() });
                                        }}
                                    >
                                        Clear Filter <i className="fa-solid fa-xmark ms-1"></i>
                                    </button>
                                </div>
                            )}
                            {/* ── Stats Filter Bar ─────────────────────────────── */}
                            {(() => {
                                const CHIPS = [
                                    { key: 'all',              label: 'All Tasks',        svg: '/assets/images/alltaskblock.svg' },
                                    { key: 'due_today',        label: 'Due Today',        svg: '/assets/images/duetodayblock.svg' },
                                    { key: 'due_in_7_days',    label: 'Due in 7 days',    svg: '/assets/images/due7dayblock.svg' },
                                    { key: 'delayed',          label: 'Delayed',          svg: '/assets/images/delayedblock.svg' },
                                    { key: 'created_by_me',    label: 'Created by me',    svg: '/assets/images/createdbymeblock.svg' },
                                    { key: 'assigned_to_me',   label: 'Assigned to me',   svg: '/assets/images/assignedtomeblockblock.svg' },
                                    { key: 'pending_approval', label: 'Pending/Approval', svg: '/assets/images/pendingapprovalblock.svg' },
                                    { key: 'recurring',        label: 'Recurring',        svg: '/assets/images/recurringblock.svg' },
                                    { key: 'complete',         label: 'Completed',        svg: '/assets/images/completedblock.svg' },
                                ];
                                return (
                                    <div style={{ display: 'flex', gap: '8px', marginBottom: '14px', flexWrap: 'nowrap' }}>
                                        {CHIPS.map((chip) => {
                                            const isActive = activeTimeFilter.includes(chip.key);
                                            const count = chipCounts[chip.key] ?? 0;
                                            return (
                                                <div
                                                    key={chip.key}
                                                    onClick={() => {
                                                        setActiveTimeFilter([chip.key]);
                                                        navigate(location.pathname, { replace: true, state: { ...location.state, taskFilter: chip.key } });
                                                    }}
                                                    className="task-stat-chip"
                                                    style={{
                                                        flex: '1 1 0',
                                                        minWidth: '0', 
                                                        height: '62px',
                                                        background: '#fff',
                                                        border: isActive ? '1px solid #0DDFAB' : '1px solid #F2F2F2',
                                                        borderRadius: '8px',
                                                        padding: '8px 10px',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-start',
                                                        justifyContent: 'space-between',
                                                        boxShadow: '0 1px 2px rgba(0,0,0,0.02)',
                                                        transition: 'border-color 0.15s',
                                                        userSelect: 'none',
                                                    }}
                                                    onMouseEnter={e => { if (!isActive) e.currentTarget.style.borderColor = '#0DDFAB'; }}
                                                    onMouseLeave={e => { if (!isActive) e.currentTarget.style.borderColor = '#E6E6E6'; }}
                                                >
                                                    {/* Icon box */}
                                                    <div style={{ width: '24px', height: '24px', borderRadius: '4px', background: '#e6f9f4', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                        <img src={chip.svg} alt={chip.label} style={{ width: '13px', height: '13px', objectFit: 'contain' }} />
                                                    </div>
                                                    {/* Label + count same row */}
                                                    <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', width: '100%', gap: '4px' }}>
                                                        <span style={{ fontSize: '11px', color: '#1D1D1D', fontWeight: '400', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0 }}>
                                                            {chip.label}
                                                        </span>
                                                        <span style={{ fontSize: '16px', fontWeight: '700', color: '#1a2332', lineHeight: 1, flexShrink: 0 }}>
                                                            {(chip.key === 'due_today' ? loading : isBackgroundLoading) ? <Skeleton width={20} /> : String(count).padStart(2, '0')}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            })()}

                            {/* ── Search + Filters + Create Task ───────────────── */}
                             <style>{`
                                .task-filters-row {
                                    display: flex;
                                    align-items: center;
                                    gap: 10px;
                                    flex-wrap: wrap;
                                    margin-bottom: 12px;
                                    min-width: 0;
                                    border-top: 1px solid #F2F2F2;
                                    border-bottom: 1px solid #F2F2F2;
                                    padding: 10px 0;
                                }
                                .task-filters-row .custom-filter.float-select-wrap .ant-select-selector,
                                .task-filters-row .custom-filter.float-select-wrap .ant-picker {
                                    height: 34px !important; min-height: 34px !important; border-radius: 6px !important;
                                    border: 1.5px solid #F2F2F2 !important;
                                }
                                .task-filters-row .float-select-wrap.custom-filter { flex: 0 1 140px; position: relative; }
                                .task-filters-row .float-select-wrap.custom-filter .ant-select-selector:hover,
                                .task-filters-row .float-select-wrap.custom-filter .ant-select-focused .ant-select-selector {
                                    border-color: #1D1D1D !important;
                                    box-shadow: none !important;
                                }
                                .task-filters-row .float-select-wrap.custom-filter:focus-within > svg,
                                .task-filters-row .float-select-wrap.custom-filter:hover > svg {
                                    color: #1D1D1D !important;
                                }
                                .task-filters-row .float-select-wrap.custom-filter:focus-within .ant-select-selector,
                                .task-filters-row .float-select-wrap.custom-filter:hover .ant-select-selector {
                                    border-color: #1D1D1D !important;
                                    box-shadow: none !important;
                                }
                                .task-filters-row .task-date-range-wrap:hover .ant-picker,
                                .task-filters-row .task-date-range-wrap .ant-picker-focused {
                                    border-color: #1D1D1D !important;
                                    box-shadow: none !important;
                                }
                                .task-filters-row .task-date-range-wrap .ant-picker-separator,
                                .task-filters-row .task-date-range-wrap .ant-picker-range-separator {
                                    color: #D2D2D2 !important;
                                }
                                .task-filters-row .task-date-range-wrap:hover .ant-picker-input > input,
                                .task-filters-row .task-date-range-wrap:hover .ant-picker-separator,
                                .task-filters-row .task-date-range-wrap:hover .ant-picker-suffix i,
                                .task-filters-row .task-date-range-wrap .ant-picker-focused .ant-picker-input > input {
                                    color: #1D1D1D !important;
                                }
                                .task-filters-row .task-date-range-wrap:hover .ant-picker-input > input::placeholder {
                                    color: #1D1D1D !important;
                                    opacity: 1 !important;
                                }
                                .task-filters-row .float-select-wrap.custom-filter.task-status-filter .ant-select-arrow {
                                    display: inline-flex !important;
                                    opacity: 1 !important;
                                    visibility: visible !important;
                                    pointer-events: none !important;
                                }
                                .task-filters-row .float-select-wrap.custom-filter.task-status-filter .ant-select-selector {
                                    padding-right: 24px !important;
                                    overflow: hidden !important;
                                }
                                .task-filters-row .float-select-wrap.custom-filter.task-status-filter > svg {
                                    position: absolute;
                                    right: 8px;
                                    top: 50%;
                                    transform: translateY(-50%);
                                    pointer-events: none;
                                    z-index: 2;
                                }
                                .task-filters-row .task-date-range-wrap { flex: 1 1 160px; min-width: 120px; width: auto !important; }
                                .task-filters-row > div[style*="marginLeft: auto"] { flex-shrink: 0; }
                                .task-filters-row .custom-filter.float-select-wrap .ant-select-selection-item,
                                .task-filters-row .custom-filter.float-select-wrap .ant-picker-input > input {
                                    line-height: 30px !important; font-size: 11px !important; font-weight: 300 !important;
                                    color: #000000d9 !important;
                                }
                                .task-filters-row .custom-filter.float-select-wrap .ant-select-selection-placeholder {
                                    line-height: 30px !important; font-size: 11px !important; font-weight: 300 !important;
                                    color: #D2D2D2 !important;
                                }
                                .task-filters-row .custom-filter.float-select-wrap .ant-select-selector {
                                    display: flex !important; align-items: center !important;
                                }
                                .task-filters-row .custom-filter.float-select-wrap .ant-select-selection-overflow {
                                    display: flex !important; align-items: center !important;
                                    flex-wrap: nowrap !important; height: 100% !important; overflow: hidden !important;
                                }
                                .task-filters-row .custom-filter.float-select-wrap .ant-select-selection-overflow-item {
                                    display: flex !important; align-items: center !important;
                                }
                                .task-filters-row .custom-filter.float-select-wrap .ant-select-selection-item {
                                    display: flex !important; align-items: center !important;
                                    height: 22px !important; line-height: 22px !important;
                                    margin: 0 !important; padding: 0 8px !important;
                                    border-radius: 4px !important; font-size: 11px !important; font-weight: 300 !important;
                                }
                                .task-filters-row .custom-filter.float-select-wrap label {
                                    position: absolute; left: 10px; top: 50%; transform: translateY(-50%);
                                    font-size: 11px !important; font-weight: 300 !important; color: #D2D2D2; background: transparent;
                                    padding: 0 4px; z-index: 10; transition: all 0.2s ease;
                                    pointer-events: none;
                                }
                                .task-filters-row .custom-filter.float-select-wrap.has-value label,
                                .task-filters-row .custom-filter.float-select-wrap:focus-within label { 
                                    top: 0; transform: translateY(-50%); font-size: 11px !important; 
                                    font-weight: 600 !important; color: #1d1d1d; background: #fff; 
                                }
                                .task-filters-row .custom-filter.float-select-wrap .ant-picker-focused,
                                .task-filters-row .custom-filter.float-select-wrap .ant-picker:hover { border-color: #1D1D1D !important; box-shadow: none !important; }
                                .task-filters-row .custom-filter.float-select-wrap .ant-select-clear { display: none !important; }
                                .task-filters-row .ant-picker-range .ant-picker-active-bar { background: #1D1D1D !important; }
                                .task-date-range-wrap { position: relative; }
                                .task-date-range-wrap::before,
                                .task-date-range-wrap::after {
                                    position: absolute; top: 0; transform: translateY(-50%);
                                    font-size: 11px !important; font-weight: 600 !important; color: #D2D2D2;
                                    background: #fff; padding: 0 3px; z-index: 10;
                                    pointer-events: none; opacity: 0; transition: color 0.2s, opacity 0.2s;
                                }
                                .task-date-range-wrap:hover::before,
                                .task-date-range-wrap:hover::after,
                                .task-date-range-wrap:focus-within::before,
                                .task-date-range-wrap:focus-within::after,
                                .task-date-range-wrap:has(.ant-picker-focused)::before,
                                .task-date-range-wrap:has(.ant-picker-focused)::after {
                                    color: #1D1D1D !important;
                                }
                                .task-date-range-wrap::before { content: 'Start Date'; left: 12px; }
                                .task-date-range-wrap::after  { content: 'End Date';   left: calc(50% + 8px); }
                                .task-date-range-wrap.has-value::before { opacity: 1; color: #1D1D1D !important; }
                                .task-date-range-wrap.has-end-value::after  { opacity: 1; color: #1D1D1D !important; }
                                .task-search-wrap { position: relative; flex: 0 1 180px; z-index: 1; }
                                .task-search-wrap input {
                                    width: 100%; height: 34px; padding: 0 36px 0 14px;
                                    border: 1.5px solid #F2F2F2; border-radius: 6px;
                                    font-size: 11px !important; font-weight: 300 !important; outline: none; background: #fff;
                                    color: #000000d9;
                                }
                                .task-search-wrap input:focus { border-color: #1D1D1D !important; box-shadow: none !important; }
                                .task-search-wrap:hover input { border-color: #1D1D1D !important; }
                                .task-search-wrap i { color: #D2D2D2 !important; }
                                .task-search-wrap input:focus ~ i, .task-search-wrap:focus-within i { color: #1D1D1D !important; }
                                .task-search-wrap:hover i { color: #1D1D1D !important; }
                                .task-search-wrap:hover label { color: #1D1D1D !important; }
                                .task-search-wrap:focus-within label { color: #1D1D1D !important; }
                                .task-filters-row .float-select-wrap.custom-filter:hover label { color: #1D1D1D !important; }
                                .task-filters-row .float-select-wrap.custom-filter:focus-within label { color: #1D1D1D !important; }
                                .task-filters-row .float-select-wrap.custom-filter.has-value label { color: #1D1D1D !important; }
                                .task-search-wrap label {
                                    position: absolute; left: 14px; top: 50%; transform: translateY(-50%);
                                    font-size: 11px !important; font-weight: 300 !important; color: #D2D2D2; pointer-events: none;
                                    transition: all 0.2s ease; background: #fff; padding: 0 2px;
                                }
                                .task-search-wrap input:focus ~ label,
                                .task-search-wrap input:not(:placeholder-shown) ~ label {
                                    top: 0; font-size: 11px !important; font-weight: 600 !important; color: #1D1D1D;
                                }
                                .task-create-btn {
                                    height: 34px; border-radius: 6px; font-size: 13px; font-weight: 600;
                                    padding: 0 12px; display: flex; align-items: center; gap: 6px;
                                    background-color: #0DDFAB; border: 1px solid #0DDFAB; color: #fff;
                                    white-space: nowrap; cursor: pointer; text-decoration: none; flex-shrink: 0;
                                }
                                .task-create-btn:hover { background-color: #0bc698; border-color: #0bc698; color: #fff; }

                                .project-select-wrap { position: relative; width: 100%; }
                                .project-select-wrap label {
                                    position: absolute; left: 10px; top: -8px; font-size: 11px;
                                    font-weight: 600; color: #1d1d1d; background: #fff;
                                    padding: 0 4px; z-index: 10;
                                }
                                .project-chip {
                                    background: #1D1D1D; color: #0DDFAB; padding: 4px 10px;
                                    border-radius: 6px; font-size: 11px; font-weight: 600;
                                    display: inline-flex; align-items: center; cursor: pointer;
                                    white-space: nowrap; max-width: 100%; overflow: hidden;
                                    text-overflow: ellipsis;
                                }
                                .add-project-link {
                                    display: flex; align-items: center; gap: 8px;
                                    color: #1d1d1d; font-size: 13px; font-weight: 500;
                                    cursor: pointer; padding: 4px 0;
                                }
                                .add-project-link i {
                                    width: 20px; height: 20px; border: 1.5px solid #d1d5db;
                                    border-radius: 5px; display: flex; align-items: center;
                                    justify-content: center; font-size: 11px; color: #9ca3af;
                                }
                                .project-option {
                                    display: flex; align-items: center; justify-content: space-between;
                                    padding: 8px 12px; font-size: 13px; font-weight: 500;
                                    color: #1d1d1d; cursor: pointer;
                                }
                                .project-option:hover { background: #f9fafb; }
                                .project-initials {
                                    width: 24px; height: 24px; border-radius: 6px;
                                    background: #0DDFAB; color: #fff; font-size: 10px;
                                    display: flex; align-items: center; justify-content: center;
                                    font-weight: 700;
                                }
                                .create-project-link {
                                    color: #0DDFAB; font-size: 13px; font-weight: 600;
                                    padding: 10px 12px; cursor: pointer; text-align: center;
                                    border-top: 1px solid #f3f4f6;
                                }

                                .task-row { position: relative; transition: background-color 0.15s; }
                                .task-row:hover { background-color: #f9fafb !important; }

                                .priority-indicator {
                                    flex-shrink: 0;
                                    align-self: stretch;
                                    width: 4px;
                                    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                                    display: flex;
                                    align-items: center;
                                    overflow: hidden;
                                    cursor: default;
                                    border-radius: 0 4px 4px 0;
                                }
                                .priority-indicator:hover {
                                    width: 50px;
                                    box-shadow: 2px 0 8px rgba(0,0,0,0.1);
                                }
                                .priority-indicator span {
                                    opacity: 0;
                                    transition: opacity 0.2s ease;
                                    white-space: nowrap;
                                    font-size: 10px;
                                    font-weight: 700;
                                    color: #1d1d1d;
                                    padding-left: 6px;
                                }
                                .priority-indicator:hover span {
                                    opacity: 1;
                                    transition-delay: 0.1s;
                                }
                             `}</style>
                            <div className="task-filters-row">
                                {/* Search */}
                                <div className="task-search-wrap">
                                    <input type="text" placeholder=" " value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
                                    <label>Search Task</label>
                                    {searchValue
                                        ? <i className="uil-times" onMouseDown={(e) => { e.preventDefault(); setSearchValue(''); }} style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: '#D2D2D2', fontSize: '15px', cursor: 'pointer', zIndex: 20 }} />
                                        : <i className="uil-search" style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: '#D2D2D2', fontSize: '15px', pointerEvents: 'none', zIndex: 20 }} />
                                    }
                                </div>

                                {/* Status */}
                                <div className={`float-select-wrap custom-filter task-status-filter ${taskFilter?.length > 0 ? 'has-value' : ''}`} style={{ flexShrink: 0, position: 'relative' }}>
                                    <label>Status</label>
                                    <Select mode="multiple" value={taskFilter} onChange={(v) => setTaskFilter(v)} allowClear placeholder="" maxTagCount={taskFilter?.length > 1 ? 0 : 1} maxTagPlaceholder={(v) => <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>{v.length} Selected <span onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); setTaskFilter([]); }} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}><i className="uil-times" style={{ fontSize: '13px', color: '#999' }} /></span></div>} style={{ width: '100%' }}>
                                        <Option value="Pending"><div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#DFA70D', flexShrink: 0 }} />Pending</div></Option>
                                        <Option value="In-Progress"><div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#607EF9', flexShrink: 0 }} />In Progress</div></Option>
                                        <Option value="On-Hold"><div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#0DDFAB', flexShrink: 0 }} />On Hold</div></Option>
                                        <Option value="Pending-Approval"><div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#1D1D1D', flexShrink: 0 }} />Pending Approval</div></Option>
                                        <Option value="Rejected"><div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#FF0000', flexShrink: 0 }} />Rejected</div></Option>
                                        <Option value="Complete"><div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#1CB333', flexShrink: 0 }} />Completed</div></Option>
                                    </Select>
                                    <ChevronDown size={14} style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', color: '#D2D2D2', pointerEvents: 'none', zIndex: 5 }} />
                                </div>

                                {/* Assigned To (admin/head only) */}
                                {(roleTitle === "Company Admin" || isHead) && (
                                    <div className={`float-select-wrap custom-filter ${userFilter?.length > 0 ? 'has-value' : ''}`} style={{ flexShrink: 0, position: 'relative' }}>
                                        <label>Assigned To</label>
                                        <Select mode="multiple" value={userFilter} onChange={(v) => setUserFilter(v)} allowClear placeholder="" maxTagCount={userFilter?.length > 1 ? 0 : 1} maxTagPlaceholder={(v) => <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>{v.length} Selected <span onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); setUserFilter([]); }} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}><i className="uil-times" style={{ fontSize: '13px', color: '#999' }} /></span></div>} showSearch filterOption={(input, option) => { const c = option.children; return String(Array.isArray(c) ? c.join('') : c).toLowerCase().includes(input.toLowerCase()); }} style={{ width: '100%' }}>
                                            {taskOwner.map((user) => (<Option key={user.id} value={user.id}>{user.first_name} {user.last_name}</Option>))}
                                        </Select>
                                        <ChevronDown size={14} style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', color: '#D2D2D2', pointerEvents: 'none', zIndex: 2 }} />
                                    </div>
                                )}

                                {/* Priority */}
                                <div className={`float-select-wrap custom-filter task-priority-filter ${priorityFilter?.length > 0 ? 'has-value' : ''}`} style={{ flexShrink: 0, position: 'relative' }}>
                                    <label>Priority</label>
                                    <Select mode="multiple" value={priorityFilter} onChange={(v) => setPriorityFilter(v)} allowClear placeholder="" maxTagCount={priorityFilter?.length > 1 ? 0 : 1} maxTagPlaceholder={(v) => <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>{v.length} Selected <span onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); setPriorityFilter([]); }} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}><i className="uil-times" style={{ fontSize: '13px', color: '#999' }} /></span></div>} showSearch filterOption={(input, option) => { const label = option.children?.props?.children?.[1]; return label ? String(label).toLowerCase().includes(input.toLowerCase()) : false; }} style={{ width: '100%' }}>
                                        {taskPriority.map((p) => (
                                            <Option key={p.id} value={String(p.id)}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <span style={{ backgroundColor: p.color, width: '10px', height: '10px', borderRadius: '50%', marginRight: '8px', display: 'inline-block' }} />
                                                    {p.name}
                                                </div>
                                            </Option>
                                        ))}
                                    </Select>
                                    <ChevronDown size={14} style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', color: '#D2D2D2', pointerEvents: 'none', zIndex: 2 }} />
                                </div>

                                {/* Date Range — placeholder text IS the label; floats when dates selected */}
                                <div className={`float-select-wrap custom-filter task-date-range-wrap ${dateRangeFilter?.[0] ? 'has-value' : ''} ${dateRangeFilter?.[1] ? 'has-end-value' : ''}`} style={{ flex: '0 1 215px' }}>
                                    <RangePicker
                                        value={dateRangeFilter}
                                        onChange={(dates) => setDateRangeFilter(dates)}
                                        allowClear
                                        separator="→"
                                        placeholder={['Start Date', 'End Date']}
                                        style={{ width: '100%' }}
                                        suffixIcon={
                                            <div style={{ backgroundColor: '#F4F4F4', borderRadius: '5px', width: '22px', height: '22px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '-4px' }}>
                                                <i className="uil-schedule" style={{ color: '#888', fontSize: '14px' }} />
                                            </div>
                                        }
                                    />
                                </div>

                                {/* Create Task */}
                                <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                                    {(userPermissions || []).indexOf("tasks-create") !== -1 && (
                                        <>
                                            <Link to="#" id="createTask" className="task-create-btn" style={{ opacity: isLoading ? 0.6 : 1, pointerEvents: isLoading ? 'none' : 'auto', marginLeft: 'auto' }} onClick={handleCreateTask}>
                                                <i className="uil-plus" style={{ fontSize: '15px' }} /> Create a Task
                                            </Link>
                                            <div style={{ display: 'none' }}>
                                                <button id="hiddenCreateTaskBtn" data-bs-toggle="modal" data-bs-target="#offcanvasRight" />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* ── Task Tables (one per active filter chip) ─────── */}
                            <div style={{ overflowX: 'auto', paddingBottom: '16px' }}>
                                <div style={{ minWidth: '1050px' }}>
                                    {(() => {
                                const CHIP_LABELS = {
                                    all: 'All Tasks', due_today: 'Due Today', due_in_7_days: 'Due in 7 Days',
                                    delayed: 'Delayed', created_by_me: 'Created by Me', assigned_to_me: 'Assigned to Me',
                                    pending_approval: 'Pending / Approval', recurring: 'Recurring', complete: 'Completed',
                                };
                                const multiMode = activeTimeFilter.length > 1;

                                const colHeader = (
                                    <div style={{ display: 'flex', alignItems: 'center', padding: '8px 0', background: '#F2F2F2' }}>
                                        <div className="task-title-col" style={{ flex: 1, minWidth: 0, paddingLeft: '36px' }}><span style={headSt}>Task Title</span></div>
                                        <div style={{ width: COL.created, flexShrink: 0, padding: '0 8px' }} className="task-col-created"><span style={headSt}>Created By</span></div>
                                        <div style={{ width: COL.assigned, flexShrink: 0, padding: '0 8px' }} className="task-col-assigned"><span style={headSt}>Assigned to</span></div>
                                        <div style={{ width: COL.date, flexShrink: 0, padding: '0 8px' }} className="task-col-date"><span style={headSt}>Due Date</span></div>
                                        <div style={{ width: COL.status, flexShrink: 0, padding: '0 6px' }} className="task-col-status"><span style={headSt}>Status</span></div>
                                        <div style={{ width: COL.comment, flexShrink: 0, padding: '0 8px' }} className="task-col-comment"><span style={headSt}>Comment</span></div>
                                        <div style={{ width: COL.project, flexShrink: 0, padding: '0 6px 0 0' }} className="task-col-project"><span style={headSt}>Project</span></div>
                                    </div>
                                );

                                return activeTimeFilter.map((filterKey, idx) => {
                                    const label = CHIP_LABELS[filterKey] || filterKey;
                                    const rows = filteredRowsByKey[filterKey] || [];
                                    const isOpen = !multiMode || openSections[filterKey] !== false; // single mode always open

                                    return (
                                        <div key={filterKey} style={{ marginBottom: idx < activeTimeFilter.length - 1 ? '20px' : '0' }}>
                                            {/* Section header */}
                                            <div
                                                style={{
                                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                    padding: '8px 4px', borderBottom: '1px solid #eaecf0',
                                                    userSelect: 'none',
                                                }}
                                            >
                                                <span style={{ fontSize: '14px', fontWeight: '700', color: '#1a2332' }}>{label}</span>
                                                {multiMode && (
                                                    <div
                                                        onClick={() => setOpenSections(prev => ({ ...prev, [filterKey]: !isOpen }))}
                                                        style={{
                                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            width: '22px', height: '22px', borderRadius: '6px',
                                                            border: '1px solid #ECECEC', background: 'transparent',
                                                            color: '#8E8E8E', cursor: 'pointer', flexShrink: 0,
                                                            transition: 'all 0.2s ease',
                                                        }}
                                                        onMouseEnter={e => { e.currentTarget.style.borderColor = '#adb5bd'; e.currentTarget.style.color = '#1D1D1D'; }}
                                                        onMouseLeave={e => { e.currentTarget.style.borderColor = '#ECECEC'; e.currentTarget.style.color = '#8E8E8E'; }}
                                                    >
                                                        <i className={isOpen ? 'uil-angle-up' : 'uil-angle-down'} style={{ fontSize: '12px', lineHeight: 1 }} />
                                                    </div>
                                                )}
                                            </div>

                                            {/* Table body */}
                                            {isOpen && (
                                                <>
                                                    {colHeader}
                                                    {(filterKey === 'due_today' ? loading : sidebarFilterData.filter === filterKey ? sidebarFilterData.loading : isBackgroundLoading) ? (
                                                        [1,2,3,4,5].map(i => (
                                                            <div key={i} style={{ display: 'flex', alignItems: 'center', padding: '12px 16px', borderBottom: '1px solid #f5f5f5' }}>
                                                                <div style={{ flex: 1 }}><Skeleton width="55%" /></div>
                                                                <div style={{ width: COL.created }}><Skeleton width="80%" /></div>
                                                                <div style={{ width: COL.assigned }}><Skeleton width="80%" /></div>
                                                                <div style={{ width: COL.date }}><Skeleton width="70%" /></div>
                                                                <div style={{ width: COL.status }}><Skeleton width="90%" /></div>
                                                                <div style={{ width: COL.comment }}><Skeleton width="50%" /></div>
                                                                <div style={{ width: COL.project }}><Skeleton width="80%" /></div>
                                                            </div>
                                                        ))
                                                    ) : rows.length === 0 ? (
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '30px 20px', color: '#9ca3af' }}>
                                                            <i className="uil-clipboard-alt" style={{ fontSize: '32px', marginBottom: '6px' }} />
                                                            <span style={{ fontSize: '13px' }}>No tasks found.</span>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <Fade big>
                                                                <div>
                                                                    {rows.slice(0, visibleTasksCount).map((item) => (
                                                                        <SubTaskRow 
                                                                            key={item.id} 
                                                                            task={item} 
                                                                            level={0} 
                                                                            userPermissions={userPermissions} 
                                                                            taskStatus={taskStatus} 
                                                                            taskOwner={taskOwner} 
                                                                            taskPriority={taskPriority} 
                                                                            projects={projects} 
                                                                            mentionUsers={mentionUsers}
                                                                            companyId={companyId}
                                                                            handlers={{
                                                                                setComplete,
                                                                                handelEditDrawer,
                                                                                handleLocalTaskUpdate,
                                                                                reSetData,
                                                                                handleOpenComments,
                                                                                openCommentTaskId,
                                                                                setOpenCommentTaskId,
                                                                                commentTaskNotes,
                                                                                setCommentTaskNotes,
                                                                                handleAddSubtask: handleAddSubtaskInline,
                                                                                handleProjectSelected,
                                                                                handleOpenCreateProjectForTask,
                                                                                inlineSubtaskParentId,
                                                                                handleInlineSubtaskCreated,
                                                                                handleCancelInlineSubtask,
                                                                            }} 
                                                                            dateLoader={dateLoader} 
                                                                            COL={COL} 
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </Fade>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    );
                                });
                            })()}
                                </div>
                            </div>
                            {/* Sentinel placed outside the map so it is always at the bottom of the page */}
                            <div id="task-list-sentinel" style={{ height: '20px' }} />
                            {isLazyLoading && (
                                <div style={{ padding: '0 16px' }}><Skeleton height={44} borderRadius={8} /></div>
                            )}
                        </>
                    </div>
                </div >
            </div >
            {/* Hidden trigger for pre-requisites modal */}
            <div id="hiddenPrereqModalBtn" style={{ display: "none" }} data-bs-toggle="modal" data-bs-target="#prereqMissingModal" />

            {/* Pre-requisites Missing — Bootstrap modal */}
            <div id="prereqMissingModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 440 }}>
                    <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                        <div className="modal-header border-0 pb-1">
                            <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Pre-requisites Missing</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body pt-2 pb-2">
                            <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "10px" }}>Please add the following first before creating a task:</p>
                            <ul style={{ listStyleType: "none", paddingLeft: 0, marginBottom: 0 }}>
                                {missingData.map((item, index) => (
                                    <li key={index} style={{ marginBottom: "8px", fontSize: "14px" }}>
                                        •{" "}
                                        <Link
                                            to={item.path}
                                            data-bs-dismiss="modal"
                                            style={{ color: "#0DDFAB", fontWeight: "bold", textDecoration: "underline" }}
                                        >
                                            {item.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="modal-footer border-0 pt-1">
                            <button type="button" className="btn btn-secondary waves-effect" data-bs-dismiss="modal" style={{ borderRadius: "5px", fontSize: "13px" }}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};



// ─── Task row (recursive — renders itself for subtasks) ────────────────────────
const SubTaskRow = ({ task, level = 0, userPermissions, taskStatus, taskOwner, handlers, dateLoader, COL, taskPriority, projects, mentionUsers, companyId, parentDueDate = null }) => {
    const userId = DataParser.UserId();
    const canEdit = !!task.can_edit;
    const canEditStatus = !!task.can_edit_status;
    const isOverdue = task.due_date && moment(task.due_date).isBefore(moment(), 'day') && task.status !== 'Complete';
    const taskProject = task.project_id ? projects?.find(p => String(p.id || p._id) === String(task.project_id)) : null;
    const effectiveMaxDate = parentDueDate || taskProject?.due_date || null;

    const rowStyle = {};
    const taskPriorityId = task.priority || task.periority;
    const priorityObj = taskPriority?.find(p => String(p.id) === String(taskPriorityId));
    const priorityName = priorityObj?.name || "";

    // Created-by display
    const creatorObj = task.task_assignee || task.assignee;
    const creatorName = `${creatorObj?.first_name || ""} ${creatorObj?.last_name || ""}`.trim();

    // Assigned-to display
    const assigneeId = task.asigned_to;
    const assigneeFromList = taskOwner?.find(u => String(u.id) === String(assigneeId));
    const assigneeObj = assigneeFromList || task.asignedd_to || task.task_assigned_to;
    const assigneeName = `${assigneeObj?.first_name || ""} ${assigneeObj?.last_name || ""}`.trim();

    const commentCount = task.comment_count || task.notes_count || 0;

    const resolvedProjectName = task.project_name || (() => {
        if (!task.project_id || !projects) return null;
        const proj = projects.find(p => String(p.id || p._id) === String(task.project_id));
        return proj?.name || proj?.project_name || null;
    })();

    const [isEditingProject, setIsEditingProject] = useState(false);
    const [isEditingSprint, setIsEditingSprint]   = useState(false);
    const [projectSprints, setProjectSprints]     = useState([]);
    const [sprintLoading, setSprintLoading]       = useState(false);
    const [pendingProject, setPendingProject]     = useState(null); // { id, label }

    const projectStyles = {
        container: (provided) => ({ ...provided, '&:focus-within': { boxShadow: 'none !important', outline: 'none !important' } }),
        control: (provided, state) => ({
            ...provided,
            minHeight: '34px',
            height: '34px',
            borderRadius: '6px',
            border: state.isFocused ? '1px solid #1d1d1d !important' : '1px solid #d1d5db !important',
            boxShadow: 'none !important',
            outline: 'none !important',
            '&:hover': { borderColor: '#1d1d1d !important' },
        }),
        valueContainer: (provided) => ({ ...provided, padding: '0 8px', height: '34px' }),
        input: (provided) => ({ ...provided, margin: '0', '& input': { boxShadow: 'none !important', outline: 'none !important' } }),
        indicatorsContainer: (provided) => ({ ...provided, height: '34px' }),
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: (provided) => ({ ...provided, padding: '0 8px' }),
        menu: (provided) => ({ ...provided, zIndex: 9999, borderRadius: '8px', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', width: '175px', minWidth: '175px' }),
        menuList: (provided) => ({ ...provided, padding: 0 }),
        menuPortal: (base) => ({ ...base, zIndex: 1000000, left: base.left + base.width - 175 }),
    };

    return (
        <>
            <div className="task-row" style={{ ...rowStyle, display: 'flex', width: '100%', alignItems: 'center', minHeight: '44px', borderBottom: '1px solid #f3f4f6', padding: '4px 0' }}>
            {(priorityObj?.color || task.priority_color) && (
                <div className="priority-indicator" style={{ backgroundColor: priorityObj?.color || task.priority_color }}>
                    <span>{priorityName}</span>
                </div>
            )}
            {/* Task Title */}
            <div className="task-title-col" style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: '8px', paddingLeft: (priorityObj?.color || task.priority_color) ? '8px' : '12px', paddingRight: '8px', overflow: 'hidden' }}>
                <input
                    className="form-check-input"
                    onChange={(e) => canEditStatus && handlers.setComplete(e, task)}
                    type="checkbox"
                    style={{ borderRadius: '5px', cursor: canEditStatus ? 'pointer' : 'default', visibility: canEditStatus ? 'visible' : 'hidden', flexShrink: 0, margin: 0 }}
                    checked={task.status === 'Complete'}
                    disabled={!canEditStatus}
                />
                <div
                    role="button"
                    onClick={(e) => handlers.handelEditDrawer(e, task.id)}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', flex: 1, minWidth: 0, overflow: 'hidden' }}
                >
                    {task.status === 'Complete' ? (
                        <del style={{ color: '#9ca3af', fontSize: '13px', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', minWidth: 0 }}>
                            {task.title}
                        </del>
                    ) : (
                        <span style={{ color: '#111827', fontSize: '13px', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', minWidth: 0 }}>
                            {task.title}
                        </span>
                    )}
                    {task.subtask_count > 0 && (
                        <div className="subtask-badge" style={{ 
                            fontSize: '11px', 
                            color: '#6b7280', 
                            background: '#f3f4f6', 
                            padding: '1px 6px', 
                            borderRadius: '4px', 
                            flexShrink: 0, 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: '3px',
                            transition: 'all 0.2s ease',
                            cursor: 'default'
                        }}>
                            <span className="subtask-svg-icon" style={{ width: '16px', height: '16px', mask: "url('/assets/images/subtask.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/subtask.svg') no-repeat center / contain" }} />
                            <span style={{ fontWeight: '400' }}>+{task.subtask_count}</span>
                        </div>
                    )}

                    {/* Hover Actions - Only show if user can edit/add subtasks */}
                    {canEdit && (
                        <div className="task-row-actions" style={{ display: 'flex', alignItems: 'center', gap: '6px', marginLeft: '4px' }}>
                            <Tooltip title="Add Subtask">
                                <div 
                                    className="task-action-btn" 
                                    onClick={(e) => handlers.handleAddSubtask(e, task)}
                                    style={{ width: '22px', height: '22px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px', background: '#f3f4f6', cursor: 'pointer', color: '#6b7280' }}
                                >
                                    <i className="uil-plus" style={{ fontSize: '14px' }} />
                                </div>
                            </Tooltip>
                            <Tooltip title="Edit Task">
                                <div 
                                    className="task-action-btn" 
                                    onClick={(e) => handlers.handelEditDrawer(e, task.id)}
                                    style={{ width: '22px', height: '22px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px', background: '#f3f4f6', cursor: 'pointer', color: '#6b7280' }}
                                >
                                    <i className="uil-edit-alt" style={{ fontSize: '14px' }} />
                                </div>
                            </Tooltip>
                        </div>
                    )}
                </div>
            </div>

            {/* Created By */}
            <div style={{ width: COL?.created || '140px', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden', padding: '0 8px' }} className="task-col-created">
                <UserProfile
                    username={creatorName || "—"}
                    userImage={creatorObj?.image}
                    bgColor="#0DDFAB"
                    style={{ width: '24px', height: '24px', flexShrink: 0, borderRadius: '6px' }}
                />
                <span style={{ fontSize: '13px', color: '#1d1d1d', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {creatorName || "—"}
                </span>
            </div>

            {/* Assigned To */}
            <div style={{ width: COL?.assigned || '150px', flexShrink: 0, overflow: 'hidden', padding: '0 8px' }} className="task-col-assigned">
                {canEdit ? (
                    <AssigneField
                        item={task}
                        assigne={taskOwner}
                        Services={TaskServices.updateTaskAssigne}
                        Owner={assigneeObj}
                        newOwner={task.asigned_to}
                        data={null}
                        reFreshData={null}
                        localUpdate={(id, data) => handlers.handleLocalTaskUpdate(id, data)}
                        avatarSize="24px"
                        bgColor="#0DDFAB"
                        textColor="#1d1d1d"
                        styles={{ fontSize: '13px' }}
                    />
                ) : (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden' }}>
                        <UserProfile
                            username={assigneeName || "Unassigned"}
                            userImage={assigneeObj?.image || assigneeObj?.profile_picture}
                            bgColor="#0DDFAB"
                            style={{ width: '24px', height: '24px', flexShrink: 0, borderRadius: '6px' }}
                        />
                        <span style={{ fontSize: '13px', color: '#1d1d1d', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {assigneeName || "Unassigned"}
                        </span>
                    </div>
                )}
            </div>

            {/* Due Date */}
            <div style={{ width: COL?.date || '120px', flexShrink: 0, overflow: 'hidden', padding: '0 8px' }} className="task-col-date">
                {canEdit ? (
                    dateLoader ? <Skeleton /> : (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <i className="uil-calendar-alt" style={{ fontSize: '20px', color: '#0DDFAB', flexShrink: 0 }} />
                            <DateField
                                item={task}
                                defaultDate={task.due_date}
                                Services={TaskServices.updateTaskDueDate}
                                data={(newDate) => handlers.handleLocalTaskUpdate(task.id, { due_date: newDate })}
                                styles={{ fontSize: '13px', color: '#1d1d1d', fontWeight: '500' }}
                                suffixIcon={null}
                                format="D, MMMM"
                                maxDate={effectiveMaxDate}
                            />
                        </div>
                    )
                ) : (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <i className="uil-calendar-alt" style={{ fontSize: '20px', color: '#0DDFAB', flexShrink: 0 }} />
                        <span style={{ fontSize: '13px', color: '#1d1d1d', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {task.due_date ? moment(task.due_date).format('D, MMMM') : '—'}
                        </span>
                    </div>
                )}
            </div>

            {/* Status */}
            <div style={{ width: COL?.status || '140px', flexShrink: 0, overflow: 'hidden', padding: '0 6px' }} className="task-col-status">
                {canEditStatus ? (
                    <LeadPendingField
                        item={task}
                        Status={taskStatus}
                        DefaultStatus={task.status}
                        Services={TaskServices.updateTaskStatus}
                        data={(e) => handlers.handleLocalTaskUpdate(task.id, { status: e.target.value })}
                    />
                ) : (
                    getStatusBadge(task.status)
                )}
            </div>

            {/* Comment */}
            <div style={{ width: COL?.comment || '90px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '6px', padding: '0 8px', overflow: 'visible' }} className="task-col-comment">
                <style>{`
                    .task-comments-popover {
                        box-shadow: none !important;
                    }
                    .task-comments-popover .ant-popover-inner {
                        border: 1px solid #F2F2F2 !important;
                        border-radius: 5px !important;
                        box-shadow: none !important;
                        background: #fff !important;
                    }
                    .task-comments-popover .ant-popover-arrow {
                        display: none !important;
                        visibility: hidden !important;
                        opacity: 0 !important;
                    }
                `}</style>
                <Popover
                    overlayStyle={{ boxShadow: 'none' }}
                    content={
                        <div style={{ width: '400px' }}>
                            <TaskNotesPopover 
                                taskId={task.id}
                                localNotes={handlers.commentTaskNotes}
                                setLocalNotes={handlers.setCommentTaskNotes}
                                mentionUsers={mentionUsers}
                                currentUserId={DataParser.UserId()}
                                companyId={companyId}
                            />
                        </div>
                    }
                    title={null}
                    trigger="click"
                    open={handlers.openCommentTaskId === task.id}
                    onOpenChange={(open) => {
                        handlers.handleOpenComments(task, open);
                    }}
                    placement="bottomRight"
                    overlayClassName="task-comments-popover"
                    getPopupContainer={trigger => trigger.parentElement}
                    mask={false}
                >
                    <div 
                        className="d-flex align-items-center gap-1 cursor-pointer" 
                        style={{ color: handlers.openCommentTaskId === task.id ? '#1d1d1d' : '#9ca3af' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handlers.handleOpenComments(task);
                        }}
                    >
                        <span className="comment-svg-icon" style={{ width: '18px', height: '18px', mask: "url('/assets/images/comment.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/comment.svg') no-repeat center / contain" }} />
                        {(() => {
                            const count = parseInt(task.final_note_count || task.notes_count || task.comment_count || task.task_notes_count || 0);
                            return count > 0 ? (
                                <span style={{ fontSize: '12px', color: '#1d1d1d', fontWeight: '600', lineHeight: 1 }}>
                                    {count}
                                </span>
                            ) : null;
                        })()}
                    </div>
                </Popover>
            </div>

            {/* Project + Sprint */}
            <div style={{ width: COL?.project || '160px', flexShrink: 0, overflow: 'visible', padding: '0 6px 0 0' }} className="task-col-project">
                {isEditingProject && canEdit ? (
                    <div className="project-select-wrap">
                        <label>Project Name</label>
                        <ReactSelect
                            autoFocus
                            styles={projectStyles}
                            options={[
                                ...(projects || []).map(p => {
                                    const name = p.project_name || p.name || "";
                                    const initials = name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
                                    return { value: p.id || p._id, label: name, initials };
                                }),
                                ...((userPermissions || []).indexOf("project-create") !== -1
                                    ? [{ value: 'create_new', label: 'Create a new project', isCreate: true }]
                                    : [])
                            ]}
                            components={{
                                Option: ({ data, innerRef, innerProps }) => (
                                    data.isCreate ? (
                                        <div ref={innerRef} {...innerProps} className="create-project-link">
                                            {data.label}
                                        </div>
                                    ) : (
                                        <div ref={innerRef} {...innerProps} className="project-option">
                                            <span>{data.label}</span>
                                        </div>
                                    )
                                )
                            }}
                            onBlur={() => setIsEditingProject(false)}
                            onChange={(option) => {
                                setIsEditingProject(false);
                                if (option.value === 'create_new') {
                                    handlers.handleOpenCreateProjectForTask(task.id);
                                    return;
                                }
                                const pid = option.value;
                                const plabel = option.label;
                                setSprintLoading(true);
                                setPendingProject({ id: pid, label: plabel });
                                SprintServices.getSprints(companyId, pid)
                                    .then(res => {
                                        const list = Array.isArray(res) ? res : (res?.data || res?.sprints || []);
                                        const active = list.filter(s => s.status !== 'Completed' && s.status !== 'completed');
                                        setProjectSprints(active);
                                        if (active.length === 0) {
                                            handlers.handleProjectSelected(task.id, pid, plabel, null, null);
                                            setPendingProject(null);
                                        } else {
                                            setIsEditingSprint(true);
                                        }
                                    })
                                    .catch(() => {
                                        handlers.handleProjectSelected(task.id, pid, plabel, null, null);
                                        setPendingProject(null);
                                    })
                                    .finally(() => setSprintLoading(false));
                            }}
                            placeholder=""
                            isSearchable
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                ) : isEditingSprint && canEdit ? (
                    <div className="project-select-wrap">
                        <label>Select Sprint</label>
                        <ReactSelect
                            autoFocus
                            styles={projectStyles}
                            options={[
                                { value: '__none__', label: 'No Sprint', isNone: true },
                                ...projectSprints.map(s => ({
                                    value: s.id,
                                    label: s.name,
                                    due_date: s.due_date,
                                    initials: s.due_date ? moment(s.due_date).format('DD MMM') : ''
                                }))
                            ]}
                            components={{
                                Option: ({ data, innerRef, innerProps }) => (
                                    data.isNone ? (
                                        <div ref={innerRef} {...innerProps} className="create-project-link" style={{ color: '#1D1D1D' }}>
                                            {data.label}
                                        </div>
                                    ) : (
                                        <div ref={innerRef} {...innerProps} className="project-option">
                                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, minWidth: 0 }}>{data.label}</span>
                                            {data.initials && (
                                                <div style={{
                                                    flexShrink: 0,
                                                    marginLeft: 8,
                                                    padding: '2px 7px',
                                                    borderRadius: 5,
                                                    background: '#0DDFAB',
                                                    color: '#fff',
                                                    fontSize: 10,
                                                    fontWeight: 700,
                                                    whiteSpace: 'nowrap',
                                                    lineHeight: '16px',
                                                }}>
                                                    {data.initials}
                                                </div>
                                            )}
                                        </div>
                                    )
                                )
                            }}
                            onBlur={() => { setIsEditingSprint(false); setPendingProject(null); }}
                            onChange={(option) => {
                                setIsEditingSprint(false);
                                if (option.value === '__none__') {
                                    handlers.handleProjectSelected(task.id, pendingProject.id, pendingProject.label, null, null);
                                    setPendingProject(null);
                                    return;
                                }
                                if (option.due_date && task.due_date && moment(task.due_date).isAfter(moment(option.due_date), 'day')) {
                                    message.error(`Task due date (${moment(task.due_date).format('DD-MM-YYYY')}) exceeds sprint due date (${moment(option.due_date).format('DD-MM-YYYY')}). Please update the task due date first.`);
                                    setPendingProject(null);
                                    return;
                                }
                                handlers.handleProjectSelected(task.id, pendingProject.id, pendingProject.label, option.value, option.label);
                                setPendingProject(null);
                            }}
                            placeholder=""
                            isSearchable
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                ) : sprintLoading ? (
                    <div style={{ fontSize: '12px', color: '#9ca3af', padding: '4px 6px' }}>Loading...</div>
                ) : (
                    resolvedProjectName ? (
                        <div
                            className="project-chip"
                            onClick={() => canEdit && (userPermissions || []).indexOf("project-list") !== -1 && setIsEditingProject(true)}
                            style={{ cursor: canEdit && (userPermissions || []).indexOf("project-list") !== -1 ? 'pointer' : 'default' }}
                        >
                            {resolvedProjectName}
                        </div>
                    ) : canEdit && (userPermissions || []).indexOf("project-list") !== -1 ? (
                        <div className="add-project-link" onClick={() => setIsEditingProject(true)}>
                            <i className="uil-plus"></i>
                            <span>Add to project</span>
                        </div>
                    ) : null
                )}
            </div>
            </div>
            {task.sub_tasks?.map((sub) => (
                <SubTaskRow
                    key={sub.id}
                    task={sub}
                    level={level + 1}
                    userPermissions={userPermissions}
                    taskStatus={taskStatus}
                    taskOwner={taskOwner}
                    handlers={handlers}
                    dateLoader={dateLoader}
                    COL={COL}
                    taskPriority={taskPriority}
                    projects={projects}
                    mentionUsers={mentionUsers}
                    companyId={companyId}
                    parentDueDate={task.due_date}
                />
            ))}
            {handlers.inlineSubtaskParentId === task.id && (
                <InlineSubtaskRow
                    parentTask={task}
                    level={level + 1}
                    taskOwner={taskOwner}
                    taskPriority={taskPriority}
                    taskStatus={taskStatus}
                    companyId={companyId}
                    COL={COL}
                    onCreated={handlers.handleInlineSubtaskCreated}
                    onCancel={handlers.handleCancelInlineSubtask}
                />
            )}
        </>
    );
};

export default Tasks;
